const moneyFormat = document.currentScript.getAttribute("money-format") || "${{amount}}";
const cartCurrencyIsoCode = document.currentScript.getAttribute("cart-currency-iso-code") || "";
const certificateURL = document.currentScript.getAttribute("certificate-url") || "";
const chevronLeftURL = document.currentScript.getAttribute("chevron-left-url") || "";
const chevronDownURL = document.currentScript.getAttribute("chevron-down-url") || "";
const shareURL = document.currentScript.getAttribute("share-url") || "";
const defaultVariantId = document.currentScript.getAttribute("default-variant-id") || "";
const withImage = document.currentScript.getAttribute("with-image") || "";
const withVideo = document.currentScript.getAttribute("with-video") || "";
const supportedShape = document.currentScript.getAttribute("supported-shape") || "";
const iconRound = document.currentScript.getAttribute("icon-round") || "";
const baseAppProxy = "https://phpstack-1090158-4289762.cloudwaysapps.com";
const asObjectParamKeys = {
  page_number: "page",
  shape_data_wrap: "shape",
  color_data_wrap: "color",
  clarity_data_wrap: "clarity",
  cut_data_wrap: "cut",
  flour_data_wrap: "fluor",
  polish_data_wrap: "polish",
  symmetry_data_wrap: "symmetry",
  lab_data_wrap: "lab",
  diamondSearchType: "type",
};
let removeParamKeysFromURL = {
  shape: 0,
  color: 0,
  clarity: 0,
  cut: 0,
  fluor: 0,
  polish: 0,
  symmetry: 0,
  lab: 0,
};
let polishDescription =
    "Polish refers to the smoothness and reflective quality of a diamond's surface, ensuring your GOODSTONE piece radiates with unparalleled brilliance and clarity",
  symmetryDescription =
    "Symmetry encompasses the precise alignment and proportion of a diamond's facets, enhancing the stone's captivating sparkle and aesthetic harmony in every GOODSTONE creation.",
  fluorescenceDescription = "Fluorescence describes the enchanting glow a diamond emits under ultraviolet light.",
  selectedSourceType = "Lab Grown";
const sidlerIndexArray = ["Marquise", "Asscher", "Pear", "Princess", "Old Miner", "Old European"];

naturalDefaultTableTo = 100;
naturalDefaultDepthTo = 100;
labGrownDefaultTableTo = 100;
labGrownDefaultDepthTo = 100;

window.PXUTheme.translation.free_price_text = "";

let ajaxCallDiamondListRunning = "No",
  myCustomController = null;
// clamp value
const getClampedValue = (configValue, diamondSearchType, valueType, checkType) => {
  const sliderSelector = diamondSearchType === "Diamond" ? ".natural-diamond-shape-slide" : ".lab-grown-diamond-shape-slide";

  const activeShapeEl = document.querySelector(`${sliderSelector} .vdb_gs-diamond-shape-item.active`);

  if (!activeShapeEl) return configValue;

  const attrName = `data-${valueType}-${checkType}`;
  const defaultValue = Number(activeShapeEl.getAttribute(attrName));

  if (!Number.isFinite(defaultValue)) return configValue;

  if (configValue == null) return defaultValue;
  if (checkType === "min" && configValue < defaultValue) return defaultValue;
  if (checkType === "max" && configValue > defaultValue) return defaultValue;

  return configValue;
};

function normalizeValue(val) {
  return String(val).trim().replace(/\s+/g, "");
}

const FILTER_VALUE_MAPS = {
  shape: {
    radiante: "Radiant",
    "radiante alargado": "Elongated Radiant",
    ovalado: "Oval",
    "cojin alargado": "Elongated Cushion",
    cojin: "Cushion",
    redondo: "Round",
    esmeralda: "Emerald",
    marquesa: "Marquise",
    pera: "Pear",
    princesa: "Princess",
    "minero antiguo": "Old Miner",
    "viejo minero": "Old Miner",
    "viejo mine": "Old Miner",
    "europeo antiguo": "Old European",
    "viejo europeo": "Old European",
    "viejo european": "Old European",
    ascher: "Asscher",
    aschuer: "Asscher",
  },
  fluor: {
    ninguno: "None",
    debil: "Faint",
    medio: "Medium",
    fuerte: "Strong",
    "muy fuerte": "Very Strong",
  },
  polish: {
    ideal: "Ideal",
    excelente: "Excellent",
    "muy bueno": "Very Good",
    bueno: "Good",
    regular: "Fair",
    malo: "Poor",
  },
  symmetry: {
    ideal: "Ideal",
    excelente: "Excellent",
    "muy bueno": "Very Good",
    bueno: "Good",
    regular: "Fair",
    malo: "Poor",
  },
  cut: {
    ideal: "Ideal",
    excelente: "Excellent",
    "muy bueno": "Very Good",
    bueno: "Good",
    regular: "Fair",
    malo: "Poor",
    "demasiado poco profundo": "Too Shallow",
    "demasiado profundo": "Too Deep",
  },
};

function normalizeFilterToken(token) {
  return String(token)
    .toLowerCase()
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ");
}

function mapFilterCsvValues(value, mapName) {
  const valueMap = FILTER_VALUE_MAPS[mapName] || {};
  return String(value || "")
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean)
    .map((item) => valueMap[normalizeFilterToken(item)] || item)
    .join(",");
}

window.NATURAL_LB_GROWN_DIAMOND = (function () {
  return {
    config: {},
    callBeforeLGDiamond: async function () {
      if (myCustomController !== null) {
        myCustomController.abort();
      }
      // totalResultIndex = 0;
      window.NATURAL_LB_GROWN_DIAMOND.config.page_number = 1;
      ajaxCallDiamondListRunning = "No";
      document.querySelector("#vdb-gs-data-body-data").innerHTML = "";
      window.NATURAL_LB_GROWN_DIAMOND.hideElements(".vdb-pagination-section");

      /* document.getElementById('search_diamond_count').innerHTML = `0 - RESULTS`;
            document.getElementById('vdb-lb-search-result-wrapper').innerHTML = ''; // window.NATURAL_LB_GROWN_DIAMOND.hideElements('.vdb-see-more-div'); */
      await window.NATURAL_LB_GROWN_DIAMOND?.callDiamondList();
    },
    callDiamondList: async function () {
      if (ajaxCallDiamondListRunning == "No") {
        ajaxCallDiamondListRunning = "Yes";
        const page_number = window.NATURAL_LB_GROWN_DIAMOND?.config.page_number;

        myCustomController = new AbortController();
        const myCustomSignal = myCustomController.signal;
        console.log("=======> table max ::", window.NATURAL_LB_GROWN_DIAMOND.config.tableMax);
        var formData = new FormData();
        formData.append("action", "getAllFilterProducts");
        formData.append("shop", Shopify.shop);
        formData.append("page_number", page_number);
        formData.append("diamondSearchType", window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType);
        formData.append("shape_data_wrap", mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.config.shapeValues, "shape"));
        formData.append("color_data_wrap", window.NATURAL_LB_GROWN_DIAMOND.config.colorValues);
        formData.append("clarity_data_wrap", window.NATURAL_LB_GROWN_DIAMOND.config.clarityValues);
        formData.append("cut_data_wrap", normalizeValue(mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.config.cutValues, "cut")));
        formData.append("flour_data_wrap", mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.config.fluorescenceValues, "fluor"));
        formData.append("polish_data_wrap", mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.config.polishValues, "polish"));
        formData.append("symmetry_data_wrap", mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.config.symmetryValues, "symmetry"));
        formData.append("lab_data_wrap", mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.config.certificateValues, "lab"));

        formData.append("price_min", window.NATURAL_LB_GROWN_DIAMOND.config.priceMin);
        formData.append("price_max", window.NATURAL_LB_GROWN_DIAMOND.config.priceMax);
        formData.append("price_pc_data_wrap", "total");

        formData.append("carat_min", window.NATURAL_LB_GROWN_DIAMOND.config.caratMin);
        formData.append("carat_max", window.NATURAL_LB_GROWN_DIAMOND.config.caratMax);

        formData.append(
          "table_min",
          getClampedValue(
            window.NATURAL_LB_GROWN_DIAMOND.config.tableMin,
            window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType,
            "table",
            "min"
          ) || (window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType == "Diamond" ? naturalDefaultTableMin : labGrownDefaultTableMin)
        );

        formData.append(
          "table_max",
          getClampedValue(
            window.NATURAL_LB_GROWN_DIAMOND.config.tableMax,
            window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType,
            "table",
            "max"
          ) || (window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType == "Diamond" ? naturalDefaultTableMax : labGrownDefaultTableMax)
        );

        formData.append(
          "depth_min",
          getClampedValue(
            window.NATURAL_LB_GROWN_DIAMOND.config.depthMin,
            window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType,
            "depth",
            "min"
          ) || (window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType == "Diamond" ? naturalDefaultDepthMin : labGrownDefaultDepthMin)
        );

        formData.append(
          "depth_max",
          getClampedValue(
            window.NATURAL_LB_GROWN_DIAMOND.config.depthMax,
            window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType,
            "depth",
            "max"
          ) || (window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType == "Diamond" ? naturalDefaultDepthMax : labGrownDefaultDepthMax)
        );

        formData.append(
          "ratio_min",
          window.NATURAL_LB_GROWN_DIAMOND.config.ratioMin ||
            (window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType == "Diamond" ? naturalDefaultRatioMin : labGrownDefaultRatioMin)
        );
        formData.append(
          "ratio_max",
          window.NATURAL_LB_GROWN_DIAMOND.config.ratioMax ||
            (window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType == "Diamond" ? naturalDefaultRatioMax : labGrownDefaultRatioMax)
        );

        formData.append("sorting_field", window.NATURAL_LB_GROWN_DIAMOND.config.sortingField);
        formData.append("sorting_seq", window.NATURAL_LB_GROWN_DIAMOND.config.sortingSeq);

        formData.append("with_images", withImage);
        formData.append("with_videos", withVideo);

        formData.append("share_proids", "");

        if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("proids") == undefined) {
          const jsonData = window.NATURAL_LB_GROWN_DIAMOND.formDataToJson(formData, [
            "action",
            "shop",
            "sorting_field",
            "sorting_seq",
            "share_proids",
            "price_pc_data_wrap",
            "with_images",
            "with_videos",
          ]);
          if (Object.keys(jsonData)?.length > 0) {
            console.log("======> Json Data :::", jsonData);
            Object.entries(jsonData).map(([key, value]) => window.NATURAL_LB_GROWN_DIAMOND.updateQueryStringParam(key, value));

            console.log("=======> removeParamKeysFromURL shape", removeParamKeysFromURL["shape"], jsonData.shape.split(",").length);
            console.log(jsonData.shape.split(",").length != removeParamKeysFromURL["shape"]);
            let vdbGSLabGrownDiamondShapeItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
              ".vdb_gs-auto_flex-grid .vdb_gs-diamond-shape-item"
            );
            vdbGSLabGrownDiamondShapeItemElements.forEach((el) => el.classList.remove("active"));
            if (jsonData.shape.split(",").length !== removeParamKeysFromURL["shape"]) {
              if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-auto_flex-grid .vdb_gs-diamond-shape-item")?.length > 0) {
                for (let i = 0; i < vdbGSLabGrownDiamondShapeItemElements?.length; i++) {
                  if (vdbGSLabGrownDiamondShapeItemElements[i].getAttribute("data-shape-value") == jsonData.shape) {
                    vdbGSLabGrownDiamondShapeItemElements[i].classList.add("active");
                  }
                }
              }
            }
          }
        }

        window.NATURAL_LB_GROWN_DIAMOND.showElements(".vdb-gs-load-more-div");
        fetch(`${baseAppProxy}/frontend.php`, {
          signal: myCustomSignal,
          method: "POST",
          body: formData,
        })
          .then((response) => response.text())
          .then((result) => {
            isQueryParams = "No";
            window.NATURAL_LB_GROWN_DIAMOND.hideElements(".vdb-gs-load-more-div");

            if (window.NATURAL_LB_GROWN_DIAMOND.isJsonOrString(result) == true) {
              let resultArray = JSON.parse(result),
                diamondsArray = [];
              if (resultArray?.main_data?.response?.body?.diamonds != undefined) {
                diamondsArray = resultArray?.main_data?.response?.body?.diamonds;
              }

              if (diamondsArray.length > 0) {
                ajaxCallDiamondListRunning = "No";
                let errorSrc = `this.src='${baseAppProxy}/images/no-image.png'`;

                if (resultArray?.total_count < resultArray?.rows) {
                  globalThis.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }

                for (x = 0; x < diamondsArray.length; x++) {
                  const dynamic_id = `pro-data-${diamondsArray[x].id}`;
                  var measurements_arr = [];
                  if (diamondsArray[x]["meas_length"] != null && diamondsArray[x]["meas_length"] != "") {
                    measurements_arr.push(diamondsArray[x]["meas_length"]);
                  } else {
                    measurements_arr.push("0.00");
                  }
                  if (diamondsArray[x]["meas_width"] != null && diamondsArray[x]["meas_width"] != "") {
                    measurements_arr.push(diamondsArray[x]["meas_width"]);
                  } else {
                    measurements_arr.push("0.00");
                  }
                  if (diamondsArray[x]["meas_depth"] != null && diamondsArray[x]["meas_depth"] != "") {
                    measurements_arr.push(diamondsArray[x]["meas_depth"]);
                  } else {
                    measurements_arr.push("0.00");
                  }
                  var measurements = measurements_arr.join("x");
                  console.log("shape name is:" + `${diamondsArray[x]?.size?.length > 0 ? diamondsArray[x]?.shape_long : "-"}`);
                  let shapeName = "icon" + `${diamondsArray[x]?.size?.length > 0 ? diamondsArray[x]?.shape : "-"}`;
                  var htmlList = `<div class="vdb_gd_data_tr">
                                    <textarea id="${dynamic_id}" style="display:none;">${JSON.stringify(diamondsArray[x])}</textarea>
                                    <div class="vdb_gd_data_body">
                                        <div class="vdb_gs-td">
                                        <span>${diamondsArray[x]?.size?.length > 0 ? diamondsArray[x]?.shape : "-"}</span>
                                    </div>
                                    <div class="vdb_gs-td">
                                            <span>${
                                              diamondsArray[x]?.total_sales_price?.length > 0
                                                ? window.NATURAL_LB_GROWN_DIAMOND.formatMoney(
                                                    Number(
                                                      window.NATURAL_LB_GROWN_DIAMOND.priceInShopCurrency(
                                                        diamondsArray[x]?.total_sales_price
                                                      )
                                                    ) * 100
                                                  )
                                                : "-"
                                            }</span>
                                        </div>
                                    <div class="vdb_gs-td">
                                            <span>${diamondsArray[x]?.size?.length > 0 ? diamondsArray[x]?.size + "ct" : "-"}</span>
                                        </div>
                                        <div class="vdb_gs-td vdb-gs-disabled-mobile">
                                            <span>${diamondsArray[x]?.color?.length > 0 ? diamondsArray[x]?.color : "-"}</span>
                                        </div>
                                        <div class="vdb_gs-td vdb-gs-disabled-mobile">
                                            <span>${diamondsArray[x]?.clarity?.length > 0 ? diamondsArray[x]?.clarity : "-"}</span>
                                        </div>
                                        <div class="vdb_gs-td vdb-gs-disabled-mobile">
                                            <span>${diamondsArray[x]?.cut?.length > 0 ? diamondsArray[x]?.cut : "Super Ideal"}</span>
                                        </div>
                                        <div class="vdb_gs-td vdb-gs-disabled-mobile">
                                            <span>${diamondsArray[x]?.lab?.length > 0 ? diamondsArray[x]?.lab : "-"}</span>
                                            ${/*<img src="${baseAppProxy}/public/no-images/certificate.png" alt="Certificate">*/ ""}
                                        </div>
                                        <div class="vdb_gs-td td--details">
                                            <span>Details</span>
                                            <img src="${chevronDownURL}" alt="Arrow">
                                        </div>
                                    </div>
                                    <div class="vdb_gs_diamond-more-details" style="display: none;">
                                        <div class="vdb_gs-product-img">
                                            <img src="${diamondsArray[x]?.image_url}" onerror="${errorSrc}" alt="${
                    diamondsArray[x]?.short_title
                  }">
                                        </div>
                                        <div class="vdb_gs-product-details">
                                            <div class="vdb_gs-product-detail-block">
                                                ${
                                                  diamondsArray[x]?.cert_url?.length > 0
                                                    ? `<div>
                                                    <span>CERTIFICATE</span>
                                                    <a href="javascript:;" data-url="${diamondsArray[x]?.cert_url}" class="vdb_gs_bottom-line vdb_gs_cert-video">VIEW</a>
                                                </div>`
                                                    : ""
                                                }
                                                ${
                                                  diamondsArray[x]?.video_url?.length > 0
                                                    ? `<div>
                                                    <span>DIAMOND VIDEO</span>
                                                    <a href="javascript:;" data-url="${diamondsArray[x]?.video_url}" class="vdb_gs_bottom-line vdb_gs_cert-video">VIEW</a>
                                                </div>`
                                                    : ""
                                                }
                                                ${
                                                  measurements?.length > 0
                                                    ? `<div>
                                                    <span>MEASUREMENTS (MM)</span>
                                                    <span>${measurements}</span>
                                                </div>`
                                                    : ""
                                                }
                                                ${
                                                  diamondsArray[x]?.meas_ratio?.length > 0
                                                    ? `<div>
                                                    <span>RATIO</span>
                                                    <span>${diamondsArray[x]?.meas_ratio}</span>
                                                </div>`
                                                    : ""
                                                }
                                                ${
                                                  diamondsArray[x]?.polish?.length > 0
                                                    ? `<div>
                                                    <span>POLISH</span>
                                                    <span>
                                                        <a href="javascript:void(0)" id="vdb_gs_polish" class="vdb_gs-info" data-type="Polish">
                                                            <span>${diamondsArray[x]?.polish}</span>
                                                            <span class="vdb_gs-info_icon">?</span>
                                                        </a>
                                                    </span>
                                                </div>`
                                                    : ""
                                                }
                                                ${
                                                  diamondsArray[x]?.symmetry?.length > 0
                                                    ? `<div>
                                                    <span>SYMMETRY</span>
                                                    <span>
                                                        <a href="javascript:void(0)" class="vdb_gs-info" data-type="Symmetry">
                                                            <span>${diamondsArray[x]?.symmetry}</span>
                                                            <span class="vdb_gs-info_icon">?</span>
                                                        </a>
                                                    </span>
                                                </div>`
                                                    : ""
                                                }
                                                ${
                                                  diamondsArray[x]?.fluor_intensity?.length > 0
                                                    ? `<div>
                                                    <span>FLUORESCENCE</span>
                                                    <span>
                                                        <a href="javascript:void(0)" class="vdb_gs-info" data-type="Fluorescence">
                                                            <span>${diamondsArray[x]?.fluor_intensity}</span>
                                                            <span class="vdb_gs-info_icon">?</span>
                                                        </a>
                                                    </span>
                                                </div>`
                                                    : ""
                                                }
                                                ${
                                                  /* <div class="vdb_gs_share"><a href="javascript:void(0)" id="vdb_gs_share">SHARE<img src="${shareURL}" alt=""></a></div> */ ""
                                                }
                                            </div>
                                            <div class="vdb_gs-select-btn">
                                                <div class="coi-wrapper is-relative">
                                                    <a href="javascript:;" rel="noopener" data-select-item="${dynamic_id}" class="button frame-corners button--secondary coi-btn cart-btn-red vdb_gs-outline-btn">
                                                        <span class="nice-frame"> <span class="text">Select this Diamond</span></span>
                                                        <span class="b-corners icon"></span>
                                                    </a>
                                                    <div id="sparkles" aria-hidden="true">
                                                        <span></span>
                                                        <span></span>
                                                        <span></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>`;
                  document.querySelector("#vdb-gs-data-body-data").innerHTML += htmlList;
                }

                if (
                  resultArray?.main_data?.response?.body?.total_diamonds_found > 1 &&
                  NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-pagination-section")?.length > 0
                ) {
                  let vdbPaginationSectionElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-pagination-section");
                  for (let i = 0; i < vdbPaginationSectionElements?.length; i++) {
                    vdbPaginationSectionElements[i].innerHTML = window.NATURAL_LB_GROWN_DIAMOND.initPaginationHTML(
                      resultArray?.current_page,
                      resultArray?.page_count
                    );
                  }
                  window.NATURAL_LB_GROWN_DIAMOND.initPaginationButtonEvent();
                  window.NATURAL_LB_GROWN_DIAMOND.showElements(".vdb-pagination-section");
                }
                window.NATURAL_LB_GROWN_DIAMOND.initCollapseListView();
                window.NATURAL_LB_GROWN_DIAMOND.initOpenListViewModel();
                window.NATURAL_LB_GROWN_DIAMOND.initSelectDiamondButton();
                window.NATURAL_LB_GROWN_DIAMOND.initOpenCertAndVideoModel();
              } else {
                // document.getElementById('search_diamond_count').innerHTML = `0 - RESULTS`;
                document.querySelector("#vdb-gs-data-body-data").innerHTML =
                  '<div class="vdb_gd_data_tr"><div class="vdb_gd_data_body"><span style="text-align: center;width: 100%;padding: 16.25px 12px;background: #f6f1ed4d;">No results found</span></div></div>';
                console.log("======> result array :::", resultArray?.total_count, resultArray?.rows);
                if (resultArray?.total_count <= resultArray?.rows) {
                  globalThis.scrollTo({
                    top: 0,
                    behavior: "smooth",
                  });
                }
              }
            } else {
              // document.getElementById('search_diamond_count').innerHTML = `0 - RESULTS`;
              document.querySelector("#vdb-gs-data-body-data").innerHTML =
                '<div class="vdb_gd_data_tr"><div class="vdb_gd_data_body"><span style="text-align: center;width: 100%;padding: 16.25px 12px;background: #f6f1ed4d;">No results found</span></div></div>';
            }
          })
          .catch((error) => console.log("error", error));
      }
    },
    initPaginationButtonEvent: function () {
      if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".pagination-button__load-number")?.length > 0) {
        let paginationButtonLoadNumberElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".pagination-button__load-number");
        for (let i = 0; i < paginationButtonLoadNumberElements.length; i++) {
          paginationButtonLoadNumberElements[i].addEventListener("click", async function () {
            const page_number = this.dataset.current_page;
            window.NATURAL_LB_GROWN_DIAMOND.config.page_number = parseInt(page_number);

            if (myCustomController !== null) {
              myCustomController.abort();
            }

            ajaxCallDiamondListRunning = "No";
            document.querySelector("#vdb-gs-data-body-data").innerHTML = "";
            window.NATURAL_LB_GROWN_DIAMOND.hideElements(".vdb-pagination-section");

            // document.getElementById('search_diamond_count').innerHTML = `0 - RESULTS`;
            // document.getElementById('vdb-lb-search-result-wrapper').innerHTML = '';

            // const targetOffset = document.getElementById('collection-results-filters').getBoundingClientRect().top + window.scrollY - 30;
            // window.scrollTo({
            //     top: targetOffset,
            //     behavior: 'smooth'
            // });
            window.scrollTo({ top: 0, behavior: "smooth" });
            await window.NATURAL_LB_GROWN_DIAMOND?.callDiamondList();
          });
        }
      }
    },
    initPaginationHTML(current_page, page_count, adjacents = 2) {
      const isMobile = window.innerWidth <= 768; // Adjust breakpoint as needed

      current_page = parseInt(current_page);
      page_count = parseInt(page_count);
      adjacents = parseInt(adjacents);

      var out = "<ul>";

      // Previous
      if (current_page === 1) {
        out += `<li><a class="vdbrb_pagination_link" href="javascript:void(0);">←</a></li>`;
      } else {
        out += `<li><a class="vdbrb_pagination_link pagination-button__load-number" href="javascript:void(0);" data-current_page="${
          current_page - 1
        }">←</a></li>`;
      }

      if (isMobile) {
        // COMPACT VERSION for mobile

        if (current_page !== 1) {
          out += `<li><a class="vdbrb_pagination_link pagination-button__load-number" data-current_page="1" href="javascript:void(0);">1</a></li>`;
        } else {
          out += `<li class="active"><a href="javascript:void(0);">1</a></li>`;
        }

        if (current_page > 3) {
          out += `<li class="disabled"><a href="javascript:void(0);">...</a></li>`;
        }

        if (current_page !== 1 && current_page !== page_count) {
          out += `<li class="active"><a href="javascript:void(0);">${current_page}</a></li>`;
        }

        if (current_page < page_count - 2) {
          out += `<li class="disabled"><a href="javascript:void(0);">...</a></li>`;
        }

        if (page_count !== current_page) {
          out += `<li><a class="vdbrb_pagination_link pagination-button__load-number" data-current_page="${page_count}" href="javascript:void(0);">${page_count}</a></li>`;
        } else {
          out += `<li class="active"><a href="javascript:void(0);">${page_count}</a></li>`;
        }
      } else {
        // FULL VERSION for desktop
        let pmin = current_page > adjacents ? current_page - adjacents : 1;
        let pmax = current_page < page_count - adjacents ? current_page + adjacents : page_count;

        if (pmin > 1) {
          out += `<li><a class="vdbrb_pagination_link pagination-button__load-number" data-current_page="1" href="javascript:void(0);">1</a></li>`;
          if (pmin > 2) {
            out += `<li class="disabled"><a href="javascript:void(0);">...</a></li>`;
          }
        }

        for (let i = pmin; i <= pmax; i++) {
          if (i === current_page) {
            out += `<li class="active"><a href="javascript:void(0);">${i}</a></li>`;
          } else {
            out += `<li><a class="vdbrb_pagination_link pagination-button__load-number" data-current_page="${i}" href="javascript:void(0);">${i}</a></li>`;
          }
        }

        if (pmax < page_count) {
          if (pmax < page_count - 1) {
            out += `<li class="disabled"><a href="javascript:void(0);">...</a></li>`;
          }
          out += `<li><a class="vdbrb_pagination_link pagination-button__load-number" data-current_page="${page_count}" href="javascript:void(0);">${page_count}</a></li>`;
        }
      }

      // Next
      if (current_page < page_count) {
        out += `<li><a class="vdbrb_pagination_link pagination-button__load-number" data-current_page="${
          current_page + 1
        }" href="javascript:void(0);">→</a></li>`;
      } else {
        out += `<li><a class="vdbrb_pagination_link" href="javascript:void(0);">→</a></li>`;
      }

      out += "</ul>";
      return out;
    },
    formatMoney: function (cents, format) {
      if (typeof cents == "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function defaultOption(opt, def) {
        return typeof opt == "undefined" ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ",");
        decimal = defaultOption(decimal, ".");
        if (isNaN(number) || number == null) {
          return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split("."),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
          cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    },
    priceInShopCurrency: function (vdb_dollar_price) {
      var shop_currency = cartCurrencyIsoCode; //USD, GBP
      var currency_rate = 1;

      //Currency variable is coming from - https://cdn.shopify.com/s/javascripts/currencies.js
      if (Currency != undefined && Currency.rates != undefined && Currency.rates[shop_currency] != undefined) {
        if (shop_currency != "USD") {
          currency_rate = Currency.rates[shop_currency];
        }
      }
      return (vdb_dollar_price / currency_rate).toFixed(2);
    },
    showElements: function (element) {
      NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(element).forEach((element) => (element.style.display = "block"));
    },
    hideElements: function (element) {
      NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(element).forEach((element) => (element.style.display = "none"));
    },
    isJsonOrString: function (str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    formDataToJson: function (formData, removeFromArray) {
      let jsonData = {};
      formData.forEach((value, key) => {
        if (!removeFromArray.includes(key)) {
          // Check if the value is a File object (e.g., for file inputs)
          if (value instanceof File) {
            jsonData[key] = value.name; // You can modify this to handle files differently if needed.
          } else {
            if (asObjectParamKeys[key]) {
              jsonData[asObjectParamKeys[key]] = value;
            } else {
              jsonData[key] = value;
            }
          }
        }
      });
      return jsonData;
    },
    objectToQueryParams: function (obj) {
      return Object.entries(obj)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");
    },
    arrayToQueryParams: function (array) {
      return array.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join("&");
    },
    getUrlParameter: function (sParam) {
      var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;
      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");

        if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
      }
    },
    updateQueryStringParam: function (key, value) {
      let isPushParamInURL = "Yes";
      if (removeParamKeysFromURL[key] && value.split(",")?.length == removeParamKeysFromURL[key]) {
        isPushParamInURL = "No";
      }

      if (isPushParamInURL == "Yes") {
        var baseUrl = [location.protocol, "//", location.host, location.pathname].join(""),
          urlQueryString = document.location.search,
          newParam = value ? key + "=" + value : "",
          params = newParam?.length > 0 && "?" + newParam;

        // If the "search" string exists, then build params from it
        if (urlQueryString) {
          keyRegex = new RegExp("([?&])" + key + "[^&]*");

          // If param exists already, update it
          if (urlQueryString.match(keyRegex) !== null) {
            params = urlQueryString.replace(keyRegex, "$1" + newParam);
          } else {
            // Otherwise, add it to end of query string
            params = newParam?.length > 0 && urlQueryString + "&" + newParam;
          }
        }

        var outputString = params.toString().replace(/&+/g, "&");
        outputString = outputString.replace("?&", "?");
        outputString = outputString.charAt(outputString.length - 1) === "&" ? outputString.slice(0, -1) : outputString;
        params && window.history.replaceState({}, "", outputString);
      }
    },
    initCollapseListView: function () {
      // Helper function to check and update overflow state
      function updateOverflowState() {
        if (screen.width < 786) {
          // Get all diamond list wrappers
          const listWrappers = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-diamond_list-wrapper");

          // Check if any details are expanded
          const anyOpen = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gd_data_body.open").length > 0;

          // Update each wrapper's overflow state
          listWrappers.forEach(function (element) {
            if (anyOpen) {
              element.scrollTo({ left: 0, behavior: "smooth" });
              element.classList.add("vdb_gs-oveflow-remove");
            } else {
              element.classList.remove("vdb_gs-oveflow-remove");
            }
          });
        }
      }

      // Set up a MutationObserver to watch for display changes
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.target.classList.contains("vdb_gs_diamond-more-details")) {
            // Check if details are hidden (display: none)
            if (mutation.target.style.display === "none") {
              // If parent doesn't have open class, ensure overflow is removed
              if (!mutation.target.closest(".vdb_gd_data_tr").querySelector(".vdb_gd_data_body").classList.contains("open")) {
                NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-diamond_list-wrapper").forEach(function (wrapper) {
                  wrapper.classList.remove("vdb_gs-oveflow-remove");
                });
              }
            }

            // Also run full update to handle all cases
            updateOverflowState();
          }
        });
      });

      // Start observing all detail elements for style changes
      NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs_diamond-more-details").forEach(function (detailElement) {
        observer.observe(detailElement, {
          attributes: true,
          attributeFilter: ["style", "class"],
        });
      });

      // Main click handler functionality
      NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-td").forEach(function (element) {
        element.addEventListener("click", function (e) {
          e.preventDefault();
          var parentTr = this.closest(".vdb_gd_data_tr");
          var moreDetailsDiv = parentTr.querySelector(".vdb_gs_diamond-more-details");

          if (moreDetailsDiv) {
            parentTr.querySelector(".vdb_gd_data_body").classList.toggle("open");
            $(moreDetailsDiv).slideToggle();
          }

          if (screen.width < 786) {
            if (document.getElementById("vdbgs-diamond-list-wrapper")) {
              document.getElementById("vdbgs-diamond-list-wrapper").scrollLeft = 0;
            }

            // Update overflow state after toggle
            updateOverflowState();
          }
          return false;
        });
      });

      // Also run on init to ensure correct initial state
      updateOverflowState();
    },
    initOpenListViewModel: function () {
      // Information Modal Function
      if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-info")) {
        let vdbGSInfoElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-info");
        for (let i = 0; i < vdbGSInfoElements?.length; i++) {
          vdbGSInfoElements[i].addEventListener("click", function (e) {
            e.preventDefault();
            let type = this.dataset.type;
            if (type == "Polish") {
              description = polishDescription;
            } else if (type == "Symmetry") {
              description = symmetryDescription;
            } else if (type == "Fluorescence") {
              description = fluorescenceDescription;
            }
            document.getElementById("vdbgs-modal-title").innerHTML = type;
            document.getElementById("vdbgs-modal-description").innerHTML = description;
            document.getElementById("vdb_gs_polish_modal").style.display = "flex";
            document.querySelector("html").classList.add("modal_open");
          });
        }
      }
    },
    initOpenCertAndVideoModel: function () {
      // Information Modal Function
      if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs_cert-video")) {
        let vdbGSCertAndVideoElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs_cert-video");
        for (let i = 0; i < vdbGSCertAndVideoElements?.length; i++) {
          vdbGSCertAndVideoElements[i].addEventListener("click", function (e) {
            e.preventDefault();
            let save_cert_data = this.dataset.url;
            var save_cert_data_arr = save_cert_data.split(".");
            var ext = save_cert_data_arr.pop();
            ext = ext.toLowerCase();

            document.getElementById("myCertAndVideoFrame").style.display = "none";
            if (save_cert_data != "") {
              if (ext == "jpg" || ext == "jpeg" || ext == "png") {
                document.getElementById("myCertImg") && (document.getElementById("myCertImg").src = save_cert_data);
              } else {
                if (document.getElementById("myCertAndVideoFrame")) {
                  document.getElementById("myCertAndVideoFrame").src = save_cert_data;
                  document.getElementById("myCertAndVideoFrame").style.display = "flex";
                }
              }
              document.getElementById("vdb_gs_cert_video_modal").style.display = "flex";
              document.querySelector("html").classList.add("modal_open");
            }
          });
        }
      }
    },
    initSelectDiamondButton: function () {
      if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-outline-btn")?.length > 0) {
        let vdbGSOutlineBtn = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-outline-btn");
        for (let i = 0; i < vdbGSOutlineBtn?.length; i++) {
          vdbGSOutlineBtn[i].addEventListener("click", function () {
            let _this = this;
            let dataSelectItem = this.dataset.selectItem;
            let productJson = document.getElementById(dataSelectItem) && document.getElementById(dataSelectItem).innerHTML;
            let productObj = JSON.parse(productJson);
            let selectedShape = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("shape") || productObj.shape;
            // let selectedShape = productObj.shape;

            console.log("=====> product json :::", productObj);

            var pathname = window.location.pathname;
            var localeMatch = pathname.match(/^(\/[a-z]{2}(?:-[A-Z]{2})?)(?:\/|$)/);
            var localePrefix = localeMatch ? localeMatch[1] : "";
            var productPath = window.location.origin + localePrefix + "/products/diamond";
            window.location = `${productPath}?stock_num=${productObj.stock_num}&stone_reference_id=${
              productObj.vendor_id
            }&type=${NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type")}&shape=${selectedShape}&proids=${productObj.id}`;
          });
        }
      }
    },
    initAddToCaratButton: function () {
      if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('[data-selected-diamond-html] > ul > li[data-click="true"]')?.length > 0) {
        const dataSelectedDiamondHtmlUlLiTrueElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
          '[data-selected-diamond-html] > ul > li[data-click="true"]'
        );
        for (let i = 0; i < dataSelectedDiamondHtmlUlLiTrueElements?.length; i++) {
          dataSelectedDiamondHtmlUlLiTrueElements[i].addEventListener("click", function () {
            NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".advance-filter-web").forEach((e) => e.classList.add("hide"));
            document.getElementById("vdb-gs-advanced-filter-view").dataset.filter = "open";

            const selectedType = NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") == "Lab_grown_Diamond" ? "Lab Grown" : "Natural";
            const tabToSelect = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-tab-wrap li a").find(
              (item) => item.dataset.type == selectedType
            );
            if (tabToSelect) {
              const target = tabToSelect.getAttribute("data-rel");
              NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-tab-wrap li a").forEach((el) => el.classList.remove("active"));
              tabToSelect.classList.add("active");
              const targetElement = document.getElementById(target);
              if (targetElement) {
                targetElement.style.opacity = 0;
                targetElement.style.display = "block";
                setTimeout(function () {
                  targetElement.style.transition = "opacity 0.5s";
                  targetElement.style.opacity = 1;
                }, 0);
              }
              NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".tab-box").forEach(function (sibling) {
                if (sibling.id !== target) {
                  sibling.style.transition = "opacity 0.5s";
                  sibling.style.opacity = 0;
                  setTimeout(function () {
                    sibling.style.display = "none";
                  }, 500);
                }
              });
              const titleEl = document.getElementById("vdb-gs-list-title");
              if (titleEl) {
                titleEl.innerHTML = `Select a ${target == "vdb_gs_lab-grown-diamonds" ? "Lab-Grown" : "Natural"} Diamond`;
              }
              var resetBtn = document.querySelector(".vdb-gs-clear-all-filters");
              if (resetBtn) {
                resetBtn.click();
              } else {
                window.NATURAL_LB_GROWN_DIAMOND.callBeforeLGDiamond();
              }
            }

            NATURAL_LB_GROWN_DIAMOND.showElements(".vdb_gs_main");
            NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs_main").forEach(
              (e) => e.classList.add("fade-in") && e.classList.add("fade-in")
            );
            document.documentElement.classList.add("gs_diamond_selection_modal_open");

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE, and Opera
          });
        }
      }

      if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('[data-selected-diamond-html] > ul > li[data-click="false"]')?.length > 0) {
        const dataSelectedDiamondHtmlUlLiFalseElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
          '[data-selected-diamond-html] > ul > li[data-click="false"]'
        );
        for (let i = 0; i < dataSelectedDiamondHtmlUlLiFalseElements?.length; i++) {
          dataSelectedDiamondHtmlUlLiFalseElements[i].addEventListener("click", function () {
            document.querySelector("[data-options-selection]").style.display = "";
            document.getElementById("data-variant-option-ring-size") &&
              (document.getElementById("data-variant-option-ring-size").style.display = "");
            document.querySelector("[data-selected-diamond-html]").style.display = "none";

            NATURAL_LB_GROWN_DIAMOND.showElements(".button--select-your-diamond");
            NATURAL_LB_GROWN_DIAMOND.showElements(".selector-wrapperx.is--custom-ring-size");
            NATURAL_LB_GROWN_DIAMOND.hideElements(".button--add-to-cart");

            const $selectYourDiamondBtn = document.querySelector(".button--select-your-diamond");
            const niceFrame = $selectYourDiamondBtn.querySelector(".nice-frame");
            niceFrame && (niceFrame.textContent = "View");

            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE, and Opera
          });
        }
      }
    },
    conObjToArrElements: function (element) {
      return Array.prototype.slice.call(document.querySelectorAll(element));
    },
    callShareProductDiamond: async function () {
      const page_number = window.NATURAL_LB_GROWN_DIAMOND?.config.page_number;

      var formData = new FormData();
      formData.append("action", "getAllFilterProducts");
      formData.append("shop", Shopify.shop);
      formData.append("page_number", page_number);
      formData.append("diamondSearchType", window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType);
      formData.append(
        "share_proids",
        window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("proids") !== undefined
          ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("proids")
          : ""
      );

      fetch(`${baseAppProxy}/frontend.php`, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.text())
        .then((result) => {
          if (window.NATURAL_LB_GROWN_DIAMOND.isJsonOrString(result) == true) {
            let resultArray = JSON.parse(result),
              diamondsArray = [];
            if (resultArray?.main_data?.response?.body?.diamonds != undefined) {
              diamondsArray = resultArray?.main_data?.response?.body?.diamonds;
            }

            if (diamondsArray.length > 0) {
              for (x = 0; x < diamondsArray.length; x++) {
                document.querySelector("[data-selected-diamond-html]").style.display =
                  NATURAL_LB_GROWN_DIAMOND.getUrlParameter("is_setting_selected") == "false" ? "none" : "";
                if (NATURAL_LB_GROWN_DIAMOND.getUrlParameter("is_setting_selected") == "true") {
                  NATURAL_LB_GROWN_DIAMOND.hideElements(".button--select-your-diamond");
                  document.querySelector("[data-options-selection]").style.display = "none";
                  document.getElementById("data-variant-option-ring-size") &&
                    (document.getElementById("data-variant-option-ring-size").style.display = "none");
                  NATURAL_LB_GROWN_DIAMOND.hideElements(".selector-wrapperx.is--custom-ring-size");
                  NATURAL_LB_GROWN_DIAMOND.showElements(".button--add-to-cart");
                } else if (NATURAL_LB_GROWN_DIAMOND.getUrlParameter("is_setting_selected") == "false") {
                  const $selectYourDiamondBtn = document.querySelector(".button--select-your-diamond");
                  const niceFrame = $selectYourDiamondBtn.querySelector(".nice-frame");
                  niceFrame && (niceFrame.textContent = "View");
                }
                NATURAL_LB_GROWN_DIAMOND.initSelectDiamondProduct(diamondsArray[x]);
              }
            }
          }
        })
        .catch((error) => console.log("error", error));
    },
    initSelectDiamondProduct(productObj) {
      const dataSelectedDiamondHtml =
        document.querySelector("[data-selected-diamond-html]") && document.querySelector("[data-selected-diamond-html]");
      document.querySelector("[data-selected-diamond-html]").style.display = "";

      NATURAL_LB_GROWN_DIAMOND.hideElements(".button--select-your-diamond");
      NATURAL_LB_GROWN_DIAMOND.hideElements(".vdb_gs_main");
      NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs_main").forEach(
        (e) => e.classList.remove("fade-in") && e.classList.remove("fade-in")
      );
      document.documentElement.classList.remove("gs_diamond_selection_modal_open");
      NATURAL_LB_GROWN_DIAMOND.showElements(".button--add-to-cart");
      document.querySelector("[data-selected-diamond-product]") &&
        (document.querySelector("[data-selected-diamond-product]").innerHTML = JSON.stringify(productObj));
      //NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('.button--add-to-cart').forEach(e => e.setAttribute('data-selected-diamond-id', `pro-data-${productObj?.id}`));

      let centerStone = [];
      productObj?.size?.length > 0 && centerStone.push(productObj?.size + "CT");
      productObj?.color?.length > 0 && centerStone.push(productObj?.color);
      productObj?.clarity?.length > 0 && centerStone.push(productObj?.clarity);

      dataSelectedDiamondHtml.innerHTML && (dataSelectedDiamondHtml.innerHTML = "");
      html = "";
      html += `<ul>
                <li data-click="true">
                    <span>Shape</span>
                    <span>${productObj?.shape}</span>
                    <span class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M2 12H20" stroke="#272727" stroke-linecap="square" stroke-linejoin="round"></path><path d="M16 7L21 12L16 17" stroke="#272727" stroke-linecap="square"></path></svg></span>    
                </li>
                <li data-click="true">
                    <span>Centerstone</span>
                    <span>${centerStone.join(" / ")}</span>
                    <span class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M2 12H20" stroke="#272727" stroke-linecap="square" stroke-linejoin="round"></path><path d="M16 7L21 12L16 17" stroke="#272727" stroke-linecap="square"></path></svg></span>    
                </li>
                <li data-click="true">
                    <span>Diamond</span>
                    <span>${window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") == "Diamond" ? "Natural" : "Lab-Grown"}</span>
                    <span class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M2 12H20" stroke="#272727" stroke-linecap="square" stroke-linejoin="round"></path><path d="M16 7L21 12L16 17" stroke="#272727" stroke-linecap="square"></path></svg></span>    
                </li>`;
      if (Array.from(document.querySelector("variant-selection")?.querySelectorAll(".single-option-selector"))?.length > 0) {
        Array.from(document.querySelector("variant-selection")?.querySelectorAll(".single-option-selector")).forEach(function (item) {
          if (item?.dataset?.optionName != "Source") {
            html += `<li data-click="false">
                            <span>${item?.dataset?.optionName}</span>
                            <span>${
                              item?.dataset?.variantOptionChosenValue?.length > 0 ? item?.dataset?.variantOptionChosenValue : "-"
                            }</span>
                            <span class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M2 12H20" stroke="#272727" stroke-linecap="square" stroke-linejoin="round"></path><path d="M16 7L21 12L16 17" stroke="#272727" stroke-linecap="square"></path></svg></span>    
                        </li>`;
          }

          if (item?.dataset?.optionName == "Source") {
            item.setAttribute("disabled", "disabled");
          }
        });
      }

      if (document.getElementById("data-variant-option-ring-size")) {
        const variantOptionRingSizeElement = document.getElementById("data-variant-option-ring-size");
        html += `<li data-click="false">
                        <span>${variantOptionRingSizeElement?.dataset?.optionName}</span>
                        <span>${
                          variantOptionRingSizeElement?.value?.length > 0 && variantOptionRingSizeElement?.value != "Send ring sizer"
                            ? variantOptionRingSizeElement?.value
                            : "-"
                        }</span>
                        <span class="arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M2 12H20" stroke="#272727" stroke-linecap="square" stroke-linejoin="round"></path><path d="M16 7L21 12L16 17" stroke="#272727" stroke-linecap="square"></path></svg></span>    
                    </li>`;
      }
      html += `</ul>`;
      dataSelectedDiamondHtml.innerHTML = html;
      window.NATURAL_LB_GROWN_DIAMOND.initAddToCaratButton();
      NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gd_data_tr").forEach(function (element) {
        element.querySelector(".vdb_gd_data_body").classList.remove("open");
        element.querySelector(".vdb_gs_diamond-more-details").style.display = "none";
      });

      document.querySelector("[data-options-selection]").style.display = "none";
      document.getElementById("data-variant-option-ring-size").style.display = "none";

      const priceUIEl = document.querySelector("[data-price-ui]"),
        customPriceUIEl = document.querySelector("[data-custom-price]"),
        priceEl = document.querySelector("[data-price] [data-price]");
      let totalProductPrice =
        Number(customPriceUIEl.getAttribute("data-custom-price")) +
        Number(window.NATURAL_LB_GROWN_DIAMOND.priceInShopCurrency(productObj?.total_sales_price));

      priceUIEl.classList.remove("price-ui--loading");
      priceEl.innerHTML = window.NATURAL_LB_GROWN_DIAMOND.formatMoney(Number(totalProductPrice) * 100);
    },
    groupCustomProductMissing: async function (cart) {
      const tmp_group = {};
      if (cart.items && cart.items.length) {
        cart.items.forEach((item) => {
          const group_name =
            item.properties && item.properties["_groupId"] !== undefined && item.properties["_groupId"] !== ""
              ? item.properties["_groupId"]
              : null;
          if (group_name != null) {
            tmp_group[group_name] = tmp_group[group_name] || [];
            tmp_group[group_name].push(item);
          }
        });
      }
      return {
        group_cart: tmp_group,
        isCheckout: !Object.keys(tmp_group).some((grp_key) => tmp_group[grp_key]?.length < 2),
      };
    },
    getDifferencesBetweenArrays: function (arr1, arr2, key) {
      const map1 = new Map(arr1.map((item) => [parseInt(item[key]), item]));
      const map2 = new Map(arr2.map((item) => [parseInt(item[key]), item]));

      const inFirstArrayOnly = arr1.filter((item) => !map2.has(parseInt(item[key])));
      const inSecondArrayOnly = arr2.filter((item) => !map1.has(parseInt(item[key])));

      const commonKeys = arr1.filter((item) => map2.has(parseInt(item[key]))).map((item) => parseInt(item[key]));
      const withDifferences = commonKeys
        .filter((keyValue) => {
          const obj1 = map1.get(keyValue);
          const obj2 = map2.get(keyValue);
          return JSON.stringify(obj1) !== JSON.stringify(obj2);
        })
        .map((keyValue) => ({
          key: keyValue,
          firstArray: map1.get(keyValue),
          secondArray: map2.get(keyValue),
        }));

      return {
        inFirstArrayOnly,
        inSecondArrayOnly,
        withDifferences,
      };
    },
    fetchAddedItemOnCart: async function () {
      return await fetch("/cart.js")
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    sleep: function (ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    addToCart: async function (formData, addToCartBtn, niceFrame, stoneProductFormData = {}) {
      let _formData = formData,
        _addToCartBtn = addToCartBtn,
        _niceFrame = niceFrame,
        _stoneProductFormData = stoneProductFormData;
      try {
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            if (!response.ok) {
              return response.json().then((errorResponse) => {
                throw {
                  status: response?.status,
                  message: errorResponse?.description,
                };
              });
            }
            return response.json();
          })
          .then(async (result) => {
            if (result?.items?.length > 0) {
              if (Object.keys(_stoneProductFormData)?.length > 0) {
                try {
                  fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(_stoneProductFormData),
                  })
                    .then((response) => {
                      if (!response.ok) {
                        return response.json().then((errorResponse) => {
                          throw {
                            status: response?.status,
                            message: errorResponse?.description,
                          };
                        });
                      }
                      return response.json();
                    })
                    .then(async (result) => {
                      if (result?.items?.length > 0) {
                        location.href = "/checkout";
                      } else {
                        swal("Oops!", result?.description, "error");
                      }
                    });
                } catch (error) {
                  console.log({ error: error });
                }
              } else {
                location.href = "/checkout";
                _addToCartBtn.removeAttribute("disabled", "disabled");
                _addToCartBtn.classList.remove("disabled");
                _niceFrame &&
                  (_niceFrame.textContent = `Select a ${
                    window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") == "Diamond" ? "Natural" : "Lab-Grown"
                  } Diamond`);
              }
            } else {
              swal("Oops!", result?.description, "error");

              _addToCartBtn.removeAttribute("disabled", "disabled");
              _addToCartBtn.classList.remove("disabled");
              _niceFrame &&
                (_niceFrame.textContent = `Select a ${
                  window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") == "Diamond" ? "Natural" : "Lab-Grown"
                } Diamond`);
            }

            /* 03-04-2024 - Start */
            // (_niceFrame) && (_niceFrame.textContent = 'Add To Cart');
            /* 03-04-2024 - End */
          })
          .catch(async (err) => {
            $addDiamondToCartTry++;
            await NATURAL_LB_GROWN_DIAMOND.sleep(3000);
            if ($addDiamondToCartTry > 10) {
              _addToCartBtn.removeAttribute("disabled", "disabled");
              _addToCartBtn.classList.remove("disabled");
              _niceFrame &&
                (_niceFrame.textContent = `Select a ${
                  window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") == "Diamond" ? "Natural" : "Lab-Grown"
                } Diamond`);

              /* 03-04-2024 - Start */
              // _niceFrame.textContent = 'Add To Cart';
              /* 03-04-2024 - End */

              swal("Oops!", err?.message, "error");
            } else {
              NATURAL_LB_GROWN_DIAMOND.addToCart(_formData, _addToCartBtn, _niceFrame, _stoneProductFormData);
            }
          });
      } catch (error) {
        console.log({ error: error });
      }
    },
    clearSortingIconElement: function () {
      if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-sorting-th")?.length > 0) {
        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-sorting-th").forEach((e) => {
          let sortingField = e.dataset.sorting_field;
          e.classList.remove("vdb_gs-sorting_desc");
          e.classList.remove("vdb_gs-sorting_asc");
          if (sortingField?.length > 0 && sortingField == defaultSortingField) {
            e.classList.add("vdb_gs-sorting_asc");
          } else {
            e.classList.add("vdb_gs-sorting_desc");
          }
        });
      }
    },
  };
})();

(function () {
  // Scroll to top function
  function scrollToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE, and Opera
  }

  //Natural Diamond shape slider
  function diamondShapeSlider() {
    if (document.querySelector(".natural-diamond-shape-slide")) {
      $(".natural-diamond-shape-slide").slick({
        infinite: false,
        slidesToShow: 8,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 8,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 7,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 6,
            },
          },
        ],
      });
    }

    if (document.querySelector(".lab-grown-diamond-shape-slide")) {
      //$('.lab-grown-diamond-shape-slide').slick('unslick');
      $(".lab-grown-diamond-shape-slide").slick({
        infinite: false,
        slidesToShow: 8,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 8,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 7,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 6,
            },
          },
        ],
      });
    }
  }

  jQuery(document).ready(function ($) {
    // diamondShapeSlider();

    // Info Collapse Function
    $(".vdb_gs-info-collapses").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("open");
      $(this).parents(".vdb_gs-filter_block").find(".vdb_gs_info_details").slideToggle();
    });

    // Diamond Selection page modal Open function
    $(".vdb_gs_main").hide();
    $(".button--select-your-diamond").on("click", function (e) {
      /* if($('#data-variant-option-ring-size').val() === 'CHOOSE RING SIZE' || $('#data-variant-option-ring-size').val() === 'Send ring sizer'){
                $('.ring-dropdown-error').text('Please choose ring size.');
                return false;
            } else {
                $('.ring-dropdown-error').text('');
            } */
      let isValue = document.querySelector("variant-selection").variant;
      if (isValue != "unavailable" && isValue != "not-selected") {
        let variantLength = 0;
        console.log(document.querySelector("variant-selection"));
        Array.from(document.querySelector("variant-selection")?.querySelectorAll(".single-option-selector")).forEach(function (item) {
          if (item?.dataset?.variantOptionChosenValue != "false") {
            variantLength++;
            if (item?.dataset?.optionName == "Source") {
              selectedSourceType = item?.dataset?.variantOptionChosenValue;
            }
          }
        });

        // if (document.getElementById('data-variant-option-ring-size').value?.length == 0) return;

        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".advance-filter-web").forEach((e) => e.classList.add("hide"));
        document.getElementById("vdb-gs-advanced-filter-view").dataset.filter = "open";
        if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("proids") == undefined) {
          if (selectedSourceType?.length > 0) {
            var tabToActivate = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-tab-wrap li a").find(function (item) {
              return item.dataset.type == selectedSourceType;
            });
            if (tabToActivate) {
              var tabTarget = tabToActivate.getAttribute("data-rel");
              NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-tab-wrap li a").forEach(function (el) {
                el.classList.remove("active");
              });
              tabToActivate.classList.add("active");
              var tabTargetEl = document.getElementById(tabTarget);
              if (tabTargetEl) {
                tabTargetEl.style.opacity = 0;
                tabTargetEl.style.display = "block";
                setTimeout(function () {
                  tabTargetEl.style.transition = "opacity 0.5s";
                  tabTargetEl.style.opacity = 1;
                }, 0);
              }
              NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".tab-box").forEach(function (s) {
                if (s.id !== tabTarget) {
                  s.style.transition = "opacity 0.5s";
                  s.style.opacity = 0;
                  setTimeout(function () {
                    s.style.display = "none";
                  }, 500);
                }
              });
              var listTitleEl = document.getElementById("vdb-gs-list-title");
              if (listTitleEl)
                listTitleEl.innerHTML = "Select a " + (tabTarget == "vdb_gs_lab-grown-diamonds" ? "Lab-Grown" : "Natural") + " Diamond";
            }
          }
        }

        //  && document.getElementById('data-variant-option-ring-size').value?.length > 0
        if (
          Array.from(document.querySelector("variant-selection")?.querySelectorAll(".single-option-selector")).length == variantLength &&
          document.querySelector("[data-selected-diamond-product]").innerHTML.length > 0
        ) {
          NATURAL_LB_GROWN_DIAMOND.initSelectDiamondProduct(
            JSON.parse(document.querySelector("[data-selected-diamond-product]").innerHTML)
          );
        } else {
          //diamondShapeSlider();
          $(".button--select-your-diamond").removeAttr("disabled");
          $(".vdb_gs_main").show();
          $(".vdb_gs_main").addClass("fade-in");
          $("html").addClass("gs_diamond_selection_modal_open");
          scrollToTop();
          var resetBtnOnOpen = document.querySelector(".vdb-gs-clear-all-filters");
          if (resetBtnOnOpen) {
            resetBtnOnOpen.click();
          }
        }
      }
    });

    // Diamond Selection page modal Close function
    $(".vdb_gs-back-btn").on("click", function (e) {
      $(".vdb_gs_main").hide();
      $(".vdb_gs_main").removeClass("fade-in");
      $("html").removeClass("gs_diamond_selection_modal_open");
    });

    // Share Modal Function
    $(".vdb_gs_share a").on("click", function (e) {
      e.preventDefault();
      $("#vdb_gs_share_modal").show();
      $("html").addClass("modal_open");
    });

    // Modal Close function
    /* $(".close_modal").on("click", function (e) {
            e.preventDefault();
            $(this).parents(".vdb_gs-costum_modal").hide();
            $("html").removeClass("modal_open");
        }); */

    // Filter show in responsive device
    $("#vdb_gs_filter_btn").on("click", function (e) {
      e.preventDefault();
      NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".advance-filter-web").forEach((e) => e.classList.add("hide"));
      document.getElementById("vdb-gs-advanced-filter-view").dataset.filter = "open";
      NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-tab-wrap li a").forEach(
        (item) => item.classList.contains("active") && item.click()
      );
      // (screen.width <= 1200) && (NATURAL_LB_GROWN_DIAMOND.hideElements('.vdb_gs_list'));
      $(".vdb_gs_filters").show();
      $(".filter-overlay").removeClass("filter-overlay--hidden");
      $("body").addClass("filter--opened");
      $("#mobile-header-sticky-wrapper").hide();
      $("#mobile-header").hide();
    });

    // Filter Hide in responsive device
    $(".vdb_gs-close_modal").on("click", function (e) {
      e.preventDefault();
      // (screen.width <= 1200) && (NATURAL_LB_GROWN_DIAMOND.showElements('.vdb_gs_list'));
      $(".vdb_gs_filters").hide();
      $(".filter-overlay").addClass("filter-overlay--hidden");
      $("body").removeClass("filter--opened");
      $("#mobile-header-sticky-wrapper").show();
      $("#mobile-header").show();
    });

    /*if (screen.width < 1080) {
            $("#vdb_gs_filter_btn").on("click", function (e) {
                e.preventDefault();
                scrollToTop();
                // diamondShapeSlider();
                return false;
            });
        } else {
            $(".button--select-your-diamond").on("click", function (e) {
                e.preventDefault();
                diamondShapeSlider();
            });
        }*/
  });
})();

jQuery(document).ready(function ($) {
  // Listen for changes in the first variation select
  $("#optionband").on("change", function () {
    var selectedValue = $(this).val();

    // Check if the selected value is "Platinum"
    if (selectedValue === "Platinum") {
      // Hide options in the second variation select
      $("#optionkarat option").show();
      $('#optionkarat option[value="14k"]').hide();
      $('#optionkarat option[value="18k"]').hide();
      $("#optionkarat").val("Platinum");
    } else if (selectedValue === "Yellow Gold" || selectedValue === "White Gold" || selectedValue === "Rose Gold") {
      $("#optionkarat option").show();
      $('#optionkarat option[value="Platinum"]').hide();
      $("#optionkarat").val("14k");
    } else {
      // Show all options in the second variation select
      $("#optionkarat option").show();
    }
  });
  $("#optionmetal").on("change", function () {
    var selectedValue = $(this).val();

    // Check if the selected value is "Platinum"
    if (selectedValue === "Platinum") {
      // Hide options in the second variation select
      $("#optionkarat option").show();
      $('#optionkarat option[value="14k"]').hide();
      $('#optionkarat option[value="18k"]').hide();
      $("#optionkarat").val("Platinum");
    } else if (selectedValue === "Yellow Gold" || selectedValue === "White Gold" || selectedValue === "Rose Gold") {
      $("#optionkarat option").show();
      $('#optionkarat option[value="Platinum"]').hide();
      $("#optionkarat").val("14k");
    } else {
      // Show all options in the second variation select
      $("#optionkarat option").show();
    }
  });
});
/* Ion Range Slider */
let naturalColorIonRangeSlider,
  naturalPriceIonRangeSlider,
  naturalCaratWeightIonRangeSlider,
  naturalClarityIonRangeSlider,
  naturalFluorescenceIonRangeSlider,
  naturalPolishIonRangeSlider,
  naturalSymmetryIonRangeSlider,
  naturalDepthIonRangeSlider,
  naturalTableIonRangeSlider,
  naturalRatioIonRangeSlider,
  labGrownColorIonRangeSlider,
  labGrownPriceIonRangeSlider,
  labGrownCaratWeightIonRangeSlider,
  labGrownClarityIonRangeSlider,
  labGrownFluorescenceIonRangeSlider,
  labGrownPolishIonRangeSlider,
  labGrownSymmetryIonRangeSlider,
  labGrownDepthIonRangeSlider,
  labGrownTableIonRangeSlider,
  labGrownRatioIonRangeSlider;

// Natural Color Range slider
var naturalColorInputValues = naturalDefaultColor?.length ? naturalDefaultColor.split(",") : [];
naturalColorIonRangeSlider = $(".natural_colors").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: naturalColorInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.colorValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
  /* onUpdate: async function (data) {
        var from_value = data.from_value;
        var to_value = data.to_value;
        window.NATURAL_LB_GROWN_DIAMOND.config.colorValues = from_value+','+to_value;
        await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    }, */
});

// Natural Price Range slider
naturalPriceIonRangeSlider = $("#natural_price").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(naturalDefaultPriceMin),
  max: Number(naturalDefaultPriceMax),
  from: Number(naturalDefaultPriceMin),
  to: Number(naturalDefaultPriceMax),
  input_values_separator: ",",
  prettify_separator: ",",
  prefix: "$",
  step: 1,
  onFinish: async function (data) {
    var from_value = Number(data.from);
    var to_value = Number(data.to);
    window.NATURAL_LB_GROWN_DIAMOND.config.priceMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.priceMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
  /* onUpdate: async function (data) {
        var from_value = Number(data.from_pretty.split(' ').join('')).toFixed(2);
        var to_value = Number(data.to_pretty.split(' ').join('')).toFixed(2);
        window.NATURAL_LB_GROWN_DIAMOND.config.priceMin = from_value;
        window.NATURAL_LB_GROWN_DIAMOND.config.priceMax = to_value;
        await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    } */
});

// Natural Carat Range slider
naturalCaratWeightIonRangeSlider = $("#natural_carat_weight").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(naturalDefaultCaratMin),
  max: Number(naturalDefaultCaratMax),
  from: Number(naturalDefaultCaratMin),
  to: Number(naturalDefaultCaratMax),
  step: 0.1,
  postfix: "ct",
  onFinish: async function (data) {
    var from_value = Number(data.from_pretty.split(" ").join("")).toFixed(2);
    var to_value = Number(data.to_pretty.split(" ").join("")).toFixed(2);
    window.NATURAL_LB_GROWN_DIAMOND.config.caratMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.caratMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
  /* onUpdate: async function (data) {
        var from_value = Number(data.from_pretty.split(' ').join('')).toFixed(2);
        var to_value = Number(data.to_pretty.split(' ').join('')).toFixed(2);
        window.NATURAL_LB_GROWN_DIAMOND.config.caratMin = from_value;
        window.NATURAL_LB_GROWN_DIAMOND.config.caratMax = to_value;
        await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    } */
});

// Natural Clarity Input Range
var naturalClarityInputValues = naturalDefaultClarity?.length ? naturalDefaultClarity.split(",") : [];
naturalClarityIonRangeSlider = $("#natural_clarity").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: naturalClarityInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.clarityValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
  /* onUpdate: async function (data) {
        var from_value = data.from_value;
        var to_value = data.to_value;
        window.NATURAL_LB_GROWN_DIAMOND.config.clarityValues = from_value+','+to_value;
        await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    } */
});

// Natural Cut Input Range
// Natural Cut Image Selectors Implementation - Similar to Lab Grown version
var naturalCutInputValues = naturalDefaultCut?.length ? naturalDefaultCut.split(",") : [];

// First, remove the existing slider if it exists
if ($("#natural_cut").data("ionRangeSlider")) {
  $("#natural_cut").data("ionRangeSlider").destroy();
}

// Hide the slider container
$("#natural_cut").hide();

// Create a container for the image selectors if it doesn't exist already
if (!$("#natural_cut_selectors").length) {
  $("<div id='natural_cut_selectors' class='vdb_gs-cut-selectors-container'></div>").insertAfter("#natural_cut");
}

// Clear any existing selectors
$("#natural_cut_selectors").empty();

// Create horizontal layout for selectors
var selectorRow = $("<div class='vdb_gs-cut-selector-row'></div>").appendTo("#natural_cut_selectors");

// SVG image URL - using the same as lab grown
const naturalCutImageUrl = "https://cdn.shopify.com/s/files/1/0252/5265/9286/files/Color.svg?v=1748278879";

// Add the image selectors for each cut value
naturalCutInputValues.forEach(function (cutValue) {
  var selector = $("<div>")
    .addClass("vdb_gs-cut-selector")
    .attr("data-cut-value", cutValue)
    .html(
      `
      <div class="vdb_gs-cut-image-wrapper">
        <img src="${naturalCutImageUrl}" alt="${cutValue} Cut" class="vdb_gs-cut-image">
      </div>
      <div class="vdb_gs-cut-label">${cutValue}</div>
    `
    )
    .on("click", async function () {
      // Get all selectors
      var allSelectors = $(".vdb_gs-cut-selector");

      // Remove active class from all selectors
      allSelectors.removeClass("active");

      // Add active class to clicked selector
      $(this).addClass("active");

      // Update the config with selected value
      window.NATURAL_LB_GROWN_DIAMOND.config.cutValues = cutValue;

      // Trigger the diamond search update
      await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });

  // Set initially active if it's the default value or first in the list
  if (naturalDefaultCut === cutValue || (naturalDefaultCut.split(",").length > 1 && naturalDefaultCut.split(",")[0] === cutValue)) {
    selector.addClass("active");
  }

  // Add selector to row
  selectorRow.append(selector);
});

// LabGrown Fluorescence Input Range
var naturalFluorescenceInputValues = naturalDefaultFluorescence?.length ? naturalDefaultFluorescence.split(",") : [];
naturalFluorescenceIonRangeSlider = $("#natural_fluorescence").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: naturalFluorescenceInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.fluorescenceValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// Natural Polish Input Range
var naturalPolishInputValues = naturalDefaultPolish?.length ? naturalDefaultPolish.split(",") : [];
naturalPolishIonRangeSlider = $("#natural_polish").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: naturalPolishInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.polishValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// Natural Symmetry Input Range
var naturalSymmetryInputValues = naturalDefaultSymmetry?.length ? naturalDefaultSymmetry.split(",") : [];
naturalSymmetryIonRangeSlider = $("#natural_symmetry").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: naturalSymmetryInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.symmetryValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// Natural Diamond Depth Range slider
naturalDepthIonRangeSlider = $("#natural_depth").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(naturalDefaultDepthMin),
  max: Number(naturalDefaultDepthMax),
  from: Number(naturalDefaultDepthFrom),
  to: Number(naturalDefaultDepthTo),
  input_values_separator: ",",
  prettify_separator: ",",
  postfix: "%",
  step: 0.1,
  onFinish: async function (data) {
    var from_value = Number(data.from);
    var to_value = Number(data.to);
    window.NATURAL_LB_GROWN_DIAMOND.config.depthMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.depthMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// Natural Diamond Table Range slider
naturalTableIonRangeSlider = $("#natural_table").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(naturalDefaultTableMin),
  max: Number(naturalDefaultTableMax),
  from: Number(naturalDefaultTableFrom),
  to: Number(naturalDefaultTableTo),
  input_values_separator: ",",
  prettify_separator: ",",
  postfix: "%",
  step: 1,
  onFinish: async function (data) {
    var from_value = Number(data.from);
    var to_value = Number(data.to);
    window.NATURAL_LB_GROWN_DIAMOND.config.tableMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.tableMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// Natural Diamond Ratio Range slider
naturalRatioIonRangeSlider = $("#natural_ratio").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(naturalDefaultRatioMin),
  max: Number(naturalDefaultRatioMax),
  from: Number(naturalDefaultRatioMin),
  to: Number(naturalDefaultRatioMax),
  input_values_separator: ",",
  prettify_separator: ",",
  step: 0.1,
  onFinish: async function (data) {
    var from_value = Number(data.from);
    var to_value = Number(data.to);
    window.NATURAL_LB_GROWN_DIAMOND.config.ratioMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.ratioMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// LabGrown Color Range slider
var labGrownColorInputValues = labGrownDefaultColor?.length ? labGrownDefaultColor.split(",") : [];
labGrownColorIonRangeSlider = $(".lab_grown_colors").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: labGrownColorInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.colorValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
  /* onUpdate: async function (data) {
        var from_value = data.from_value;
        var to_value = data.to_value;
        window.NATURAL_LB_GROWN_DIAMOND.config.colorValues = from_value+','+to_value;
        await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    } */
});

// LabGrown Diamond Price Range slider
labGrownPriceIonRangeSlider = $("#lab_grown_price").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(labGrownDefaultPriceMin),
  max: Number(labGrownDefaultPriceMax),
  from: Number(labGrownDefaultPriceMin),
  to: Number(labGrownDefaultPriceMax),
  input_values_separator: ",",
  prettify_separator: ",",
  prefix: "$",
  step: 1,
  onFinish: async function (data) {
    var from_value = Number(data.from);
    var to_value = Number(data.to);
    window.NATURAL_LB_GROWN_DIAMOND.config.priceMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.priceMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
  /* onUpdate: async function (data) {
        var from_value = Number(data.from_pretty.split(' ').join('')).toFixed(2);
        var to_value = Number(data.to_pretty.split(' ').join('')).toFixed(2);
        window.NATURAL_LB_GROWN_DIAMOND.config.priceMin = from_value;
        window.NATURAL_LB_GROWN_DIAMOND.config.priceMax = to_value;
        await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    } */
});

// LabGrown Carat Range slider
labGrownCaratWeightIonRangeSlider = $("#lab_grown_carat_weight").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(labGrownDefaultCaratMin),
  max: Number(labGrownDefaultCaratMax),
  from: Number(labGrownDefaultCaratMin),
  to: Number(labGrownDefaultCaratMax),
  step: 0.1,
  postfix: "ct",
  onFinish: async function (data) {
    var from_value = Number(data.from_pretty.split(" ").join("")).toFixed(2);
    var to_value = Number(data.to_pretty.split(" ").join("")).toFixed(2);
    window.NATURAL_LB_GROWN_DIAMOND.config.caratMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.caratMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
  /* onUpdate: async function (data) {
        var from_value = Number(data.from_pretty.split(' ').join('')).toFixed(2);
        var to_value = Number(data.to_pretty.split(' ').join('')).toFixed(2);
        window.NATURAL_LB_GROWN_DIAMOND.config.caratMin = from_value;
        window.NATURAL_LB_GROWN_DIAMOND.config.caratMax = to_value;
        await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    } */
});

// LabGrown Clarity Input Range
var labGrownClarityInputValues = labGrownDefaultClarity?.length ? labGrownDefaultClarity.split(",") : [];
labGrownClarityIonRangeSlider = $("#lab_grown_clarity").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: labGrownClarityInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.clarityValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
  /* onUpdate: async function (data) {
        var from_value = data.from_value;
        var to_value = data.to_value;
        window.NATURAL_LB_GROWN_DIAMOND.config.clarityValues = from_value+','+to_value;
        await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    } */
});

// LabGrown Cut Input Range
// LabGrown Cut Image Selectors Implementation - Single-select version
var labGrownCutInputValues = labGrownDefaultCut?.length ? labGrownDefaultCut.split(",") : [];

// First, remove the existing slider if it exists
if ($("#lab_grown_cut").data("ionRangeSlider")) {
  $("#lab_grown_cut").data("ionRangeSlider").destroy();
}

// Hide the slider container
$("#lab_grown_cut").hide();

// Create a container for the image selectors if it doesn't exist already
if (!$("#lab_grown_cut_selectors").length) {
  $("<div id='lab_grown_cut_selectors' class='vdb_gs-cut-selectors-container'></div>").insertAfter("#lab_grown_cut");
}

// Clear any existing selectors
$("#lab_grown_cut_selectors").empty();

// Create horizontal layout for selectors
var selectorRow = $("<div class='vdb_gs-cut-selector-row'></div>").appendTo("#lab_grown_cut_selectors");

// SVG image URL
const cutImageUrl = "https://cdn.shopify.com/s/files/1/0252/5265/9286/files/Color.svg?v=1748278879";

// Add the image selectors for each cut value
labGrownCutInputValues.forEach(function (cutValue) {
  var selector = $("<div>")
    .addClass("vdb_gs-cut-selector")
    .attr("data-cut-value", cutValue)
    .html(
      `
      <div class="vdb_gs-cut-image-wrapper">
        <img src="${cutImageUrl}" alt="${cutValue} Cut" class="vdb_gs-cut-image">
      </div>
      <div class="vdb_gs-cut-label">${cutValue}</div>
    `
    )
    .on("click", async function () {
      // Get all selectors
      var allSelectors = $(".vdb_gs-cut-selector");

      // Remove active class from all selectors
      allSelectors.removeClass("active");

      // Add active class to clicked selector
      $(this).addClass("active");

      // Update the config with selected value
      window.NATURAL_LB_GROWN_DIAMOND.config.cutValues = cutValue;

      // Trigger the diamond search update
      await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });

  // Set initially active if it's the default value or first in the list
  if (labGrownDefaultCut === cutValue || (labGrownDefaultCut.split(",").length > 1 && labGrownDefaultCut.split(",")[0] === cutValue)) {
    selector.addClass("active");
  }

  // Add selector to row
  selectorRow.append(selector);
});

// Add CSS for the image selectors
$("<style>")
  .prop("type", "text/css")
  .html(
    `
    
    
    .vdb_gs-cut-selector-row {
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }
    
    .vdb_gs-cut-selector {
      display: flex;
      flex-direction: column;
      align-items: center;
      cursor: pointer;
      transition: all 0.2s ease;
      width: calc(33.333% - 10px);
    }
    
    .vdb_gs-cut-image-wrapper {
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 8px;
      border: 2px solid #e0e0e0;
      border-radius: 50%;
      padding: 10px;
      transition: all 0.2s ease;
    }
    
    .vdb_gs-cut-selector:hover .vdb_gs-cut-image-wrapper {
      border-color: #272727;
    }
    
    .vdb_gs-cut-selector.active .vdb_gs-cut-image-wrapper {
      border-color: #272727;
    }
    
    .vdb_gs-cut-image {
      max-width: 100%;
      max-height: 100%;
      transition: all 0.2s ease;
    }
    
    .vdb_gs-cut-label {
      font-size: 14px;
      text-align: center;
    }
    
    
    
    /* Make active label bold */
    .vdb_gs-cut-selector.active .vdb_gs-cut-label {
      font-weight: bold;
    }
    
    /* Responsive adjustments */
    @media (max-width: 768px) {
      .vdb_gs-cut-selector {
        width: calc(50% - 10px);
      }
    }
    
    @media (max-width: 480px) {
      .vdb_gs-cut-image-wrapper {
        width: 50px;
        height: 50px;
      }
    }
  `
  )
  .appendTo("head");

// LabGrown Fluorescence Input Range
var labGrownFluorescenceInputValues = labGrownDefaultFluorescence?.length ? labGrownDefaultFluorescence.split(",") : [];
labGrownFluorescenceIonRangeSlider = $("#lab_grown_fluorescence").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: labGrownFluorescenceInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.fluorescenceValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// LabGrown Polish Input Range
var labGrownPolishInputValues = labGrownDefaultPolish?.length ? labGrownDefaultPolish.split(",") : [];
labGrownPolishIonRangeSlider = $("#lab_grown_polish").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: labGrownPolishInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.polishValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// LabGrown Symmetry Input Range
var labGrownSymmetryInputValues = labGrownDefaultSymmetry?.length ? labGrownDefaultSymmetry.split(",") : [];
labGrownSymmetryIonRangeSlider = $("#lab_grown_symmetry").ionRangeSlider({
  type: "double",
  skin: "round",
  from: 0,
  grid: true,
  grid_snap: true,
  force_edges: true,
  hide_min_max: true,
  values: labGrownSymmetryInputValues,
  onFinish: async function (data) {
    var from_value = data.from_value;
    var to_value = data.to_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.symmetryValues = from_value + "," + to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// LabGrown Diamond Depth Range slider
labGrownDepthIonRangeSlider = $("#lab_grown_depth").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(labGrownDefaultDepthMin),
  max: Number(labGrownDefaultDepthMax),
  from: Number(labGrownDefaultDepthFrom),
  to: Number(labGrownDefaultDepthTo),
  input_values_separator: ",",
  prettify_separator: ",",
  postfix: "%",
  step: 0.1,
  onFinish: async function (data) {
    var from_value = Number(data.from);
    var to_value = Number(data.to);
    window.NATURAL_LB_GROWN_DIAMOND.config.depthMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.depthMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// LabGrown Diamond Table Range slider
labGrownTableIonRangeSlider = $("#lab_grown_table").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(labGrownDefaultTableMin),
  max: Number(labGrownDefaultTableMax),
  from: Number(labGrownDefaultTableFrom),
  to: Number(labGrownDefaultTableTo),
  input_values_separator: ",",
  prettify_separator: ",",
  postfix: "%",
  step: 1,
  onFinish: async function (data) {
    var from_value = Number(data.from);
    var to_value = Number(data.to);
    window.NATURAL_LB_GROWN_DIAMOND.config.tableMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.tableMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});

// LabGrown Diamond Ratio Range slider
labGrownRatioIonRangeSlider = $("#lab_grown_ratio").ionRangeSlider({
  type: "double",
  skin: "round",
  grid: false,
  grid_snap: true,
  force_edges: true,
  min: Number(),
  max: Number(labGrownDefaultRatioMax),
  from: Number(labGrownDefaultRatioMin),
  to: Number(labGrownDefaultRatioMax),
  input_values_separator: ",",
  prettify_separator: ",",
  step: 0.1,
  onFinish: async function (data) {
    var from_value = Number(data.from);
    var to_value = Number(data.to);
    window.NATURAL_LB_GROWN_DIAMOND.config.ratioMin = from_value;
    window.NATURAL_LB_GROWN_DIAMOND.config.ratioMax = to_value;
    await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
  },
});
/* END - ALL */

async function onLoadSetDefaultDataDiamond() {
  console.log("=========> onLoadSetDefaultDataDiamond");
  let type = "",
    shapeValues = "",
    priceMin = "",
    priceMax = "",
    caratMin = "",
    caratMax = "",
    tableMin = "",
    tableMax = "",
    depthMin = "",
    depthMax = "",
    colorValues = "",
    clarityValues = "",
    cutValues = "",
    fluorescenceValues = "",
    polishValues = "",
    symmetryValues = "",
    ratioMin = "",
    ratioMax = "",
    certificateValues = "";
  let vdbGSNaturalDiamondShapeItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
    ".vdb_gs-auto_flex-grid .vdb_gs-natural-diamond-shape-item.is-active-shape"
  );
  let vdbGSLabGrownDiamondShapeItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
    ".vdb_gs-auto_flex-grid .vdb_gs-lab-grown-diamond-shape-item.is-active-shape"
  );

  const queryParams = {
    shape: "Round",
  };
  // console.log('=====> onload event', window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter('shape'));
  const url = new URL(window.location);
  for (const key in queryParams) {
    if (queryParams.hasOwnProperty(key)) {
      if (key == "shape" && window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("shape")) continue;
      console.log("=====> setting up the shape");
      url.searchParams.set(key, queryParams[key]);
    }
  }
  window.history.replaceState(null, "", url);

  if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") == "Diamond") {
    type = "Diamond";
    shapeValues = supportedShape?.length > 0 ? supportedShape : naturalDefaultShape;
    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("shape")) {
      shapeValues = mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("shape"), "shape");
      vdbGSNaturalDiamondShapeItemElements.forEach((item) => item.dataset.shapeValue == shapeValues && item.classList.add("active"));
      vdbGSNaturalDiamondShapeItemElements.forEach((item) => {
        if (item.dataset.shapeValue == shapeValues && shapeValues?.split(",").length == 1) {
          tableMin = item?.dataset?.tableMin;
          tableMax = item?.dataset?.tableMax;

          depthMin = item?.dataset?.depthMin;
          depthMax = item?.dataset?.depthMax;
        }
      });
    }

    priceMin = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_min")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_min"))
      : Number(naturalDefaultPriceMin);
    priceMax = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_max")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_max"))
      : Number(naturalDefaultPriceMax);
    caratMin = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_min")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_min")).toFixed(2)
      : Number(naturalDefaultCaratMin);
    caratMax = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_max")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_max")).toFixed(2)
      : Number(naturalDefaultCaratMax);
    colorValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color")
      : naturalDefaultColor;
    clarityValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity")
      : naturalDefaultClarity;
    fluorescenceValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor")
      : naturalDefaultFluorescence;
    polishValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish")
      : naturalDefaultPolish;
    symmetryValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry")
      : naturalDefaultSymmetry;
    certificateValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab")
      : naturalDefaultGradingCertificate;

    cutValues = naturalDefaultCut;
    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("cut")) {
      cutValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("cut");
      let vdbGSNaturalDiamondCutItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-natural-diamond-cut-item");
      vdbGSNaturalDiamondCutItemElements.forEach((item) => item.dataset.cutValue == cutValues && item.classList.add("active"));
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_min") && window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_max")) {
      naturalPriceIonRangeSlider.data("ionRangeSlider").update({ from: priceMin, to: priceMax });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_min") && window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_max")) {
      naturalCaratWeightIonRangeSlider.data("ionRangeSlider").update({ from: caratMin, to: caratMax });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color")) {
      let colorData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color").split(",");
      naturalColorIonRangeSlider.data("ionRangeSlider").update({
        from: naturalColorInputValues.indexOf(colorData[0]),
        to: naturalColorInputValues.indexOf(colorData[colorData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity")) {
      let clarityData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity").split(",");
      naturalClarityIonRangeSlider.data("ionRangeSlider").update({
        from: naturalClarityInputValues.indexOf(clarityData[0]),
        to: naturalClarityInputValues.indexOf(clarityData[clarityData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor")) {
      let fluorData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor").split(",");
      naturalFluorescenceIonRangeSlider.data("ionRangeSlider").update({
        from: naturalFluorescenceInputValues.indexOf(fluorData[0]),
        to: naturalFluorescenceInputValues.indexOf(fluorData[fluorData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish")) {
      let polishData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish").split(",");
      naturalPolishIonRangeSlider.data("ionRangeSlider").update({
        from: naturalFluorescenceInputValues.indexOf(polishData[0]),
        to: naturalFluorescenceInputValues.indexOf(polishData[polishData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry")) {
      let symmetryData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry").split(",");
      naturalSymmetryIonRangeSlider.data("ionRangeSlider").update({
        from: naturalSymmetryInputValues.indexOf(symmetryData[0]),
        to: naturalSymmetryInputValues.indexOf(symmetryData[symmetryData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("ratio_min") && window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("ratio_max")) {
      naturalRatioIonRangeSlider.data("ionRangeSlider").update({ from: ratioMin, to: ratioMax });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab")) {
      const labData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab").split(",");
      labData.forEach(
        (value) =>
          document.querySelector(`[name="natural_grading_certificate"][value="${value}"]`) &&
          (document.querySelector(`[name="natural_grading_certificate"][value="${value}"]`).checked = true)
      );
    }

    removeParamKeysFromURL = {
      shape: naturalDefaultShape.split(",").length,
      color: naturalDefaultColor.split(",").length,
      clarity: naturalDefaultClarity.split(",").length,
      cut: naturalDefaultCut.split(",").length,
      fluor: naturalDefaultFluorescence.split(",").length,
      polish: naturalDefaultPolish.split(",").length,
      symmetry: naturalDefaultSymmetry.split(",").length,
      lab: naturalDefaultGradingCertificate.split(",").length,
    };
  } else {
    type = "Lab_grown_Diamond";
    shapeValues = supportedShape?.length > 0 ? supportedShape : labGrownDefaultShape;
    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("shape")) {
      shapeValues = mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("shape"), "shape");
      vdbGSLabGrownDiamondShapeItemElements.forEach((item) => item.dataset.shapeValue == shapeValues && item.classList.add("active"));
      vdbGSLabGrownDiamondShapeItemElements.forEach((item) => {
        if (item.dataset.shapeValue == shapeValues && shapeValues?.split(",").length == 1) {
          tableMin = item?.dataset?.tableMin;
          tableMax = item?.dataset?.tableMax;
          depthMin = item?.dataset?.depthMin;
          depthMax = item?.dataset?.depthMax;
        }
      });
    }

    priceMin = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_min")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_min"))
      : Number(labGrownDefaultPriceMin);
    priceMax = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_max")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_max"))
      : Number(labGrownDefaultPriceMax);
    caratMin = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_min")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_min")).toFixed(2)
      : Number(labGrownDefaultCaratMin);
    caratMax = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_max")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_max")).toFixed(2)
      : Number(labGrownDefaultCaratMax);
    colorValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color")
      : labGrownDefaultColor;
    clarityValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity")
      : labGrownDefaultClarity;
    fluorescenceValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor")
      : labGrownDefaultFluorescence;
    polishValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish")
      : labGrownDefaultPolish;
    symmetryValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry")
      : labGrownDefaultSymmetry;
    certificateValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab")
      ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab")
      : labGrownDefaultGradingCertificate;
    ratioMin = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("ratio_min")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("ratio_min"))
      : Number(labGrownDefaultRatioMin);
    ratioMax = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("ratio_max")
      ? Number(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("ratio_max"))
      : Number(labGrownDefaultRatioMax);

    cutValues = labGrownDefaultCut;
    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("cut")) {
      cutValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("cut");
      let vdbGSLabGrownDiamondCutItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-lab-grown-diamond-cut-item");
      vdbGSLabGrownDiamondCutItemElements.forEach((item) => item.dataset.cutValue == cutValues && item.classList.add("active"));
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_min") && window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("price_max")) {
      labGrownPriceIonRangeSlider.data("ionRangeSlider").update({ from: priceMin, to: priceMax });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_min") && window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("carat_max")) {
      labGrownCaratWeightIonRangeSlider.data("ionRangeSlider").update({ from: caratMin, to: caratMax });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color")) {
      let colorData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color").split(",");
      labGrownColorIonRangeSlider.data("ionRangeSlider").update({
        from: labGrownColorInputValues.indexOf(colorData[0]),
        to: labGrownColorInputValues.indexOf(colorData[colorData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity")) {
      let clarityData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity").split(",");
      labGrownClarityIonRangeSlider.data("ionRangeSlider").update({
        from: labGrownClarityInputValues.indexOf(clarityData[0]),
        to: labGrownClarityInputValues.indexOf(clarityData[clarityData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor")) {
      let fluorData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor").split(",");
      labGrownFluorescenceIonRangeSlider.data("ionRangeSlider").update({
        from: labGrownFluorescenceInputValues.indexOf(fluorData[0]),
        to: labGrownFluorescenceInputValues.indexOf(fluorData[fluorData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish")) {
      let polishData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish").split(",");
      labGrownPolishIonRangeSlider.data("ionRangeSlider").update({
        from: labGrownFluorescenceInputValues.indexOf(polishData[0]),
        to: labGrownFluorescenceInputValues.indexOf(polishData[polishData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry")) {
      let symmetryData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry").split(",");
      labGrownSymmetryIonRangeSlider.data("ionRangeSlider").update({
        from: labGrownSymmetryInputValues.indexOf(symmetryData[0]),
        to: labGrownSymmetryInputValues.indexOf(symmetryData[symmetryData?.length - 1]),
      });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("ratio_min") && window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("ratio_max")) {
      labGrownRatioIonRangeSlider.data("ionRangeSlider")?.update({ from: ratioMin, to: ratioMax });
    }

    if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab")) {
      const labData = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab").split(",");
      labData.forEach(
        (value) =>
          document.querySelector(`[name="lab_grown_grading_certificate"][value="${value}"]`) &&
          (document.querySelector(`[name="lab_grown_grading_certificate"][value="${value}"]`).checked = true)
      );
    }

    removeParamKeysFromURL = {
      shape: labGrownDefaultShape.split(",").length,
      color: labGrownDefaultColor.split(",").length,
      clarity: labGrownDefaultClarity.split(",").length,
      cut: labGrownDefaultCut.split(",").length,
      fluor: labGrownDefaultFluorescence.split(",").length,
      polish: labGrownDefaultPolish.split(",").length,
      symmetry: labGrownDefaultSymmetry.split(",").length,
      lab: labGrownDefaultGradingCertificate.split(",").length,
    };
  }

  if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("shape") == undefined && supportedShape?.length > 0) {
    console.log("======> Supported Shape :::", supportedShape);
    vdbGSNaturalDiamondShapeItemElements.forEach((item) => item.dataset.shapeValue == supportedShape && item.classList.add("active"));
    vdbGSLabGrownDiamondShapeItemElements.forEach((item) => item.dataset.shapeValue == supportedShape && item.classList.add("active"));
  }

  document.getElementById("vdb-gs-list-title") &&
    (document.getElementById("vdb-gs-list-title").innerHTML = `Select a ${type == "Lab_grown_Diamond" ? "Lab-Grown" : "Natural"} Diamond`);
  if (type == "Diamond") {
    let vdbGSTabWrapLiAElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-tab-wrap li a");
    for (let i = 0; i < vdbGSTabWrapLiAElements?.length; i++) {
      var target = vdbGSTabWrapLiAElements[i].getAttribute("data-rel");
      if (target == "vdb_gs_natural-diamonds") {
        // Remove 'active' class from all tabs
        vdbGSTabWrapLiAElements.forEach((el) => el.classList.remove("active"));

        // Add 'active' class to the clicked tab
        vdbGSTabWrapLiAElements[i].classList.add("active");
        var targetElement = document.getElementById(target);

        // Fade in the target element
        targetElement.style.opacity = 0;
        targetElement.style.display = "block";

        setTimeout(function () {
          targetElement.style.transition = "opacity 0.5s";
          targetElement.style.opacity = 1;
        }, 0);

        // Hide siblings with a fadeOut effect
        var siblings = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".tab-box");
        siblings.forEach(function (sibling) {
          if (sibling.id !== target) {
            sibling.style.transition = "opacity 0.5s";
            sibling.style.opacity = 0;
            setTimeout(function () {
              sibling.style.display = "none";
            }, 500);
          }
        });
      }
    }
  }

  NATURAL_LB_GROWN_DIAMOND.clearSortingIconElement();
  window.NATURAL_LB_GROWN_DIAMOND.config = {
    page_number: 1,
    diamondSearchType: type,
    shapeValues: shapeValues,
    colorValues: colorValues,
    clarityValues: clarityValues,
    cutValues: cutValues,
    priceMin: priceMin,
    priceMax: priceMax,
    caratMin: caratMin,
    caratMax: caratMax,
    tableMin: tableMin,
    tableMax: tableMax,
    depthMin: depthMin,
    depthMax: depthMax,
    fluorescenceValues: fluorescenceValues,
    polishValues: polishValues,
    symmetryValues: symmetryValues,
    ratioMin: ratioMin,
    ratioMax: ratioMax,
    certificateValues: certificateValues,
    sortingField: defaultSortingField,
    sortingSeq: defaultSortingSeq,
  };
  await window.NATURAL_LB_GROWN_DIAMOND?.callDiamondList();
}

async function runModalInit() {
  await onLoadSetDefaultDataDiamond();
  /* if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter('proids') !== undefined) {
        await window.NATURAL_LB_GROWN_DIAMOND?.callShareProductDiamond();
    } */

  // setTimeout(() => {
  //     $(".lab-grown-diamond-shape-slide") && ($(".lab-grown-diamond-shape-slide").slick('slickGoTo', sidlerIndexArray.findIndex(e => e == window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter('shape'))));
  //     $(".natural-diamond-shape-slide") && ($(".natural-diamond-shape-slide").slick('slickGoTo', sidlerIndexArray.findIndex(e => e == window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter('shape'))));
  // }, 1000);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", runModalInit);
} else {
  runModalInit();
}

/* function displayWindowSize() {;
    let myWidth = window.innerWidth;
    NATURAL_LB_GROWN_DIAMOND.showElements('.vdb_gs_list');
    if (myWidth <= 1200) {
        NATURAL_LB_GROWN_DIAMOND.hideElements('.vdb_gs_list');
    }
}
window.onresize = displayWindowSize; */

// Tabbing Function
if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-tab-wrap li a")?.length > 0) {
  let vdbGSTabWrapLiAElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-tab-wrap li a");
  for (let i = 0; i < vdbGSTabWrapLiAElements.length; i++) {
    vdbGSTabWrapLiAElements[i].addEventListener("click", async function () {
      var target = this.getAttribute("data-rel");

      // Remove 'active' class from all tabs
      vdbGSTabWrapLiAElements.forEach((el) => el.classList.remove("active"));

      // Add 'active' class to the clicked tab
      this.classList.add("active");
      var targetElement = document.getElementById(target);

      // Fade in the target element
      targetElement.style.opacity = 0;
      targetElement.style.display = "block";

      setTimeout(function () {
        targetElement.style.transition = "opacity 0.5s";
        targetElement.style.opacity = 1;
      }, 0);

      // Hide siblings with a fadeOut effect
      var siblings = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".tab-box");
      siblings.forEach(function (sibling) {
        if (sibling.id !== target) {
          sibling.style.transition = "opacity 0.5s";
          sibling.style.opacity = 0;
          setTimeout(function () {
            sibling.style.display = "none";
          }, 500);
        }
      });

      document.getElementById("vdb-gs-list-title") &&
        (document.getElementById("vdb-gs-list-title").innerHTML = `Select a ${
          target == "vdb_gs_lab-grown-diamonds" ? "Lab-Grown" : "Natural"
        } Diamond`);

      let shapeValues = "",
        priceMin = "",
        priceMax = "",
        caratMin = "",
        caratMax = "",
        tableMin = "",
        tableMax = "",
        depthMin = "",
        depthMax = "",
        colorValues = "",
        clarityValues = "",
        cutValues = "",
        fluorescenceValues = "",
        polishValues = "",
        symmetryValues = "",
        ratioMin = "",
        ratioMax = "",
        certificateValues = "",
        sortingField = defaultSortingField,
        sortingSeq = defaultSortingSeq;
      if (target == "vdb_gs_lab-grown-diamonds") {
        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-auto_flex-grid .vdb_gs-lab-grown-diamond-shape-item.is-active-shape").forEach(
          (item) => item.classList.contains("active") && (shapeValues = item.dataset.shapeValue)
        );
        // (shapeValues?.length == 0 && (shapeValues = labGrownDefaultShape));
        shapeValues?.length == 0 &&
          (shapeValues = mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("shape") || "Round", "shape"));

        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-auto_flex-grid .vdb_gs-lab-grown-diamond-shape-item.is-active-shape").forEach(
          (item) => {
            if (item.dataset.shapeValue == shapeValues && shapeValues?.split(",").length == 1) {
              tableMin = item?.dataset?.tableMin;
              tableMax = item?.dataset?.tableMax;

              depthMin = item?.dataset?.depthMin;
              depthMax = item?.dataset?.depthMax;
            }
          }
        );

        priceMin = labGrownPriceIonRangeSlider.data("ionRangeSlider")?.result?.from;
        priceMax = labGrownPriceIonRangeSlider.data("ionRangeSlider")?.result?.to;

        caratMin = labGrownCaratWeightIonRangeSlider.data("ionRangeSlider")?.result?.from;
        caratMax = labGrownCaratWeightIonRangeSlider.data("ionRangeSlider")?.result?.to;
        tableMin = labGrownTableIonRangeSlider.data("ionRangeSlider")?.result?.from;
        tableMax = labGrownTableIonRangeSlider.data("ionRangeSlider")?.result?.to;
        depthMin = labGrownDepthIonRangeSlider.data("ionRangeSlider")?.result?.from;
        depthMax = labGrownDepthIonRangeSlider.data("ionRangeSlider")?.result?.to;
        ratioMin = labGrownRatioIonRangeSlider.data("ionRangeSlider")?.result?.from;
        ratioMax = labGrownRatioIonRangeSlider.data("ionRangeSlider")?.result?.to;

        colorValues = `${labGrownColorInputValues[labGrownColorIonRangeSlider.data("ionRangeSlider")?.result?.from]},${
          labGrownColorInputValues[labGrownColorIonRangeSlider.data("ionRangeSlider")?.result?.to]
        }`;
        clarityValues = `${labGrownClarityInputValues[labGrownClarityIonRangeSlider.data("ionRangeSlider")?.result?.from]},${
          labGrownClarityInputValues[labGrownClarityIonRangeSlider.data("ionRangeSlider")?.result?.to]
        }`;
        fluorescenceValues = `${labGrownFluorescenceInputValues[labGrownFluorescenceIonRangeSlider.data("ionRangeSlider")?.result?.from]},${
          labGrownFluorescenceInputValues[labGrownFluorescenceIonRangeSlider.data("ionRangeSlider")?.result?.to]
        }`;
        polishValues = `${labGrownPolishInputValues[labGrownPolishIonRangeSlider.data("ionRangeSlider")?.result?.from]},${
          labGrownPolishInputValues[labGrownPolishIonRangeSlider.data("ionRangeSlider")?.result?.to]
        }`;
        symmetryValues = `${labGrownSymmetryInputValues[labGrownSymmetryIonRangeSlider.data("ionRangeSlider")?.result?.from]},${
          labGrownSymmetryInputValues[labGrownSymmetryIonRangeSlider.data("ionRangeSlider")?.result?.to]
        }`;
        certificateValues = labGrownDefaultGradingCertificate;

        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-lab-grown-diamond-cut-item").forEach(
          (item) => item.classList.contains("active") && (cutValues = item.dataset.cutValue)
        );
        cutValues?.length == 0 && (cutValues = labGrownDefaultCut);

        // if ($(".lab-grown-diamond-shape-slide").slick('refresh')) {
        //     $(".lab-grown-diamond-shape-slide").slick('refresh');
        // }
      } else {
        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-auto_flex-grid .vdb_gs-natural-diamond-shape-item.is-active-shape").forEach(
          (item) => item.classList.contains("active") && (shapeValues = item.dataset.shapeValue)
        );
        // (shapeValues?.length == 0 && (shapeValues = labGrownDefaultShape));
        shapeValues?.length == 0 &&
          (shapeValues = mapFilterCsvValues(window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("shape") || "Round", "shape"));
        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-auto_flex-grid .vdb_gs-natural-diamond-shape-item.is-active-shape").forEach(
          (item) => {
            if (item.dataset.shapeValue == shapeValues && shapeValues?.split(",").length == 1) {
              tableMin = item?.dataset?.tableMin;
              tableMax = item?.dataset?.tableMax;

              depthMin = item?.dataset?.depthMin;
              depthMax = item?.dataset?.depthMax;
            }
          }
        );

        priceMin = naturalPriceIonRangeSlider.data("ionRangeSlider")?.result?.from;
        priceMax = naturalPriceIonRangeSlider.data("ionRangeSlider")?.result?.to;

        caratMin = naturalCaratWeightIonRangeSlider.data("ionRangeSlider")?.result?.from;
        caratMax = naturalCaratWeightIonRangeSlider.data("ionRangeSlider")?.result?.to;
        tableMin = naturalTableIonRangeSlider.data("ionRangeSlider")?.result?.from;
        tableMax = naturalTableIonRangeSlider.data("ionRangeSlider")?.result?.to;
        depthMin = naturalDepthIonRangeSlider.data("ionRangeSlider")?.result?.from;
        depthMax = naturalDepthIonRangeSlider.data("ionRangeSlider")?.result?.to;
        ratioMin = naturalRatioIonRangeSlider.data("ionRangeSlider")?.result?.from;
        ratioMax = naturalRatioIonRangeSlider.data("ionRangeSlider")?.result?.to;

        colorValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color")
          ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("color")
          : naturalDefaultColor;
        clarityValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity")
          ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("clarity")
          : naturalDefaultClarity;
        fluorescenceValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor")
          ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("fluor")
          : naturalDefaultFluorescence;
        polishValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish")
          ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("polish")
          : naturalDefaultPolish;
        symmetryValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry")
          ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("symmetry")
          : naturalDefaultSymmetry;
        certificateValues = window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab")
          ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("lab")
          : naturalDefaultGradingCertificate;

        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-natural-diamond-cut-item").forEach(
          (item) => item.classList.contains("active") && (cutValues = item.dataset.cutValue)
        );
        cutValues?.length == 0 && (cutValues = naturalDefaultCut);
        // if ($(".natural-diamond-shape-slide").slick('refresh')) {
        //     $(".natural-diamond-shape-slide").slick('refresh');
        // }
      }

      // Array.from(document.querySelector('variant-selection')?.querySelectorAll('.single-option-selector')).forEach(function (item) {
      //     if (item?.dataset?.optionName == 'Source') {
      //         item.value = target == 'vdb_gs_lab-grown-diamonds' ? 'Lab Grown' : 'Natural';
      //         item.dispatchEvent(new Event('change'));
      //     }
      // });

      top.window.history.pushState({}, "", `?type=${target == "vdb_gs_lab-grown-diamonds" ? "Lab_grown_Diamond" : "Diamond"}`);

      NATURAL_LB_GROWN_DIAMOND.clearSortingIconElement();
      window.NATURAL_LB_GROWN_DIAMOND.config = {
        page_number: 1,
        diamondSearchType:
          window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") !== undefined
            ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type")
            : "Lab_grown_Diamond",
        shapeValues: shapeValues,
        colorValues: colorValues,
        clarityValues: clarityValues,
        cutValues: cutValues,
        priceMin: priceMin,
        priceMax: priceMax,
        caratMin: caratMin,
        caratMax: caratMax,
        tableMin: tableMin,
        tableMax: tableMax,
        depthMin: depthMin,
        depthMax: depthMax,
        fluorescenceValues: fluorescenceValues,
        polishValues: polishValues,
        symmetryValues: symmetryValues,
        ratioMin: ratioMin,
        ratioMax: ratioMax,
        certificateValues: certificateValues,
        sortingField: sortingField,
        sortingSeq: sortingSeq,
      };
      await window.NATURAL_LB_GROWN_DIAMOND.callBeforeLGDiamond();
      return false;
    });
  }
}

//Natural Diamond Shape active function
if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-auto_flex-grid .vdb_gs-natural-diamond-shape-item.is-active-shape")?.length > 0) {
  let vdbGSNaturalDiamondShapeItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
    ".vdb_gs-auto_flex-grid .vdb_gs-natural-diamond-shape-item.is-active-shape"
  );
  for (let i = 0; i < vdbGSNaturalDiamondShapeItemElements?.length; i++) {
    vdbGSNaturalDiamondShapeItemElements[i].addEventListener("click", async function () {
      var hasActive = this.classList.contains("active");
      var shapeValue = this.dataset.shapeValue;

      vdbGSNaturalDiamondShapeItemElements.forEach((item) => item.classList.remove("active"));
      if (!hasActive) {
        this.classList.add("active");
      } else {
        shapeValue = naturalDefaultShape;
      }
      window.NATURAL_LB_GROWN_DIAMOND.config.shapeValues = shapeValue;
      window.NATURAL_LB_GROWN_DIAMOND.config.tableMin = this?.dataset?.tableMin;
      window.NATURAL_LB_GROWN_DIAMOND.config.tableMax = this?.dataset?.tableMax;
      window.NATURAL_LB_GROWN_DIAMOND.config.depthMin = this?.dataset?.depthMin;
      window.NATURAL_LB_GROWN_DIAMOND.config.depthMax = this?.dataset?.depthMax;
      await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });
  }
}

//Natural Diamond Color action function
/*if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('.vdb_gs-natural-diamond-color-item')?.length > 0) {
    let vdbGSNaturalDiamondColorItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('.vdb_gs-natural-diamond-color-item');
    for (let i = 0; i < vdbGSNaturalDiamondColorItemElements?.length; i++) {
        vdbGSNaturalDiamondColorItemElements[i].addEventListener('click', function (e) {
            var colorValues = this.dataset.colorValues.split('-');
            naturalColorIonRangeSlider.data("ionRangeSlider").update({
                from: naturalColorInputValues.indexOf(colorValues[0]),
                to: naturalColorInputValues.indexOf(colorValues[(colorValues.length-1)])
            });
        });
    }
}*/

//Natural Diamond Clarity action function
/*if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('.vdb_gs-natural-diamond-clarity-item')?.length > 0) {
    let vdbGSNaturalDiamondClarityItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('.vdb_gs-natural-diamond-clarity-item');
    for (let i = 0; i < vdbGSNaturalDiamondClarityItemElements?.length; i++) {
        vdbGSNaturalDiamondClarityItemElements[i].addEventListener('click', function (e) {
            var clarityValues = this.dataset.clarityValues.split('-');
            naturalClarityIonRangeSlider.data("ionRangeSlider").update({
                from: naturalClarityInputValues.indexOf(clarityValues[0]),
                to: naturalClarityInputValues.indexOf(clarityValues[(clarityValues.length-1)])
            });
        });
    }
}*/

//Natural Diamond Cut active function
if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-natural-diamond-cut-item")?.length > 0) {
  let vdbGSNaturalDiamondCutItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-natural-diamond-cut-item");
  for (let i = 0; i < vdbGSNaturalDiamondCutItemElements?.length; i++) {
    vdbGSNaturalDiamondCutItemElements[i].addEventListener("click", async function () {
      var hasActive = this.classList.contains("active");
      var cutValue = this.dataset.cutValue;

      vdbGSNaturalDiamondCutItemElements.forEach((item) => item.classList.remove("active"));
      if (!hasActive) {
        this.classList.add("active");
      }
      window.NATURAL_LB_GROWN_DIAMOND.config.cutValues = cutValue;
      await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });
  }
}

//LabGrown Diamond Shape active function
if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-auto_flex-grid .vdb_gs-diamond-shape-item")?.length > 0) {
  let vdbGSLabGrownDiamondShapeItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
    ".vdb_gs-auto_flex-grid .vdb_gs-diamond-shape-item"
  );
  for (let i = 0; i < vdbGSLabGrownDiamondShapeItemElements?.length; i++) {
    vdbGSLabGrownDiamondShapeItemElements[i].addEventListener("click", async function () {
      var hasActive = this.classList.contains("active");
      var shapeValue = this.dataset.shapeValue;

      vdbGSLabGrownDiamondShapeItemElements.forEach((item) => item.classList.remove("active"));
      if (!hasActive) {
        this.classList.add("active");
      } else {
        shapeValue = labGrownDefaultShape;
      }
      window.NATURAL_LB_GROWN_DIAMOND.config.shapeValues = shapeValue;
      window.NATURAL_LB_GROWN_DIAMOND.config.tableMin = this?.dataset?.tableMin;
      window.NATURAL_LB_GROWN_DIAMOND.config.tableMax = this?.dataset?.tableMax;
      window.NATURAL_LB_GROWN_DIAMOND.config.depthMin = this?.dataset?.depthMin;
      window.NATURAL_LB_GROWN_DIAMOND.config.depthMax = this?.dataset?.depthMax;
      await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });
  }
}

//LabGrown Diamond Grading Certificate active function
if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('[name="lab_grown_grading_certificate"]')?.length > 0) {
  let vdbGSLabGrownDiamondGradingCertificateItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
    '[name="lab_grown_grading_certificate"]'
  );
  for (let i = 0; i < vdbGSLabGrownDiamondGradingCertificateItemElements?.length; i++) {
    vdbGSLabGrownDiamondGradingCertificateItemElements[i].addEventListener("click", async function () {
      window.NATURAL_LB_GROWN_DIAMOND.config.certificateValues = vdbGSLabGrownDiamondGradingCertificateItemElements
        .filter((e) => e.checked)
        .map((e) => e.value)
        .join(",");
      await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });
  }
}

// if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-auto_flex-grid .vdb_gs-natural-diamond-shape-item")?.length > 0) {
//     let vdbGSLabGrownDiamondShapeItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-auto_flex-grid .vdb_gs-natural-diamond-shape-item");
//     for (let i = 0; i < vdbGSLabGrownDiamondShapeItemElements?.length; i++) {
//         vdbGSLabGrownDiamondShapeItemElements[i].addEventListener("click", async function () {
//             var hasActive = this.classList.contains("active");
//             var shapeValue = this.dataset.shapeValue;

//             vdbGSLabGrownDiamondShapeItemElements.forEach((item) => item.classList.remove("active"));
//             if (!hasActive) {
//                 this.classList.add("active");
//             }
//             window.NATURAL_LB_GROWN_DIAMOND.config.shapeValues = shapeValue;
//             window.NATURAL_LB_GROWN_DIAMOND.config.tableMin = this?.dataset?.tableMin;
//             window.NATURAL_LB_GROWN_DIAMOND.config.tableMax = this?.dataset?.tableMax;
//             window.NATURAL_LB_GROWN_DIAMOND.config.depthMin = this?.dataset?.depthMin;
//             window.NATURAL_LB_GROWN_DIAMOND.config.depthMax = this?.dataset?.depthMax;
//             await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
//         });
//     }
// }

//LabGrown Diamond Color action function
/*if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('.vdb_gs-lab-grown-diamond-color-item')?.length > 0) {
    let vdbGSLabGrownDiamondColorItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('.vdb_gs-lab-grown-diamond-color-item');
    for (let i = 0; i < vdbGSLabGrownDiamondColorItemElements?.length; i++) {
        vdbGSLabGrownDiamondColorItemElements[i].addEventListener('click', function (e) {
            var colorValues = this.dataset.colorValues.split('-');
            labGrownColorIonRangeSlider.data("ionRangeSlider").update({
                from: labGrownColorInputValues.indexOf(colorValues[0]),
                to: labGrownColorInputValues.indexOf(colorValues[(colorValues.length-1)])
            });
        });
    }
}*/

//LabGrown Diamond Clarity action function
/*if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('.vdb_gs-lab-grown-diamond-clarity-item')?.length > 0) {
    let vdbGSLabGrownDiamondClarityItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('.vdb_gs-lab-grown-diamond-clarity-item');
    for (let i = 0; i < vdbGSLabGrownDiamondClarityItemElements?.length; i++) {
        vdbGSLabGrownDiamondClarityItemElements[i].addEventListener('click', function (e) {
            var clarityValues = this.dataset.clarityValues.split('-');
            labGrownClarityIonRangeSlider.data("ionRangeSlider").update({
                from: labGrownClarityInputValues.indexOf(clarityValues[0]),
                to: labGrownClarityInputValues.indexOf(clarityValues[(clarityValues.length-1)])
            });
        });
    }
}*/

//Natural Diamond Grading Certificate active function
if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('[name="natural_grading_certificate"]')?.length > 0) {
  let vdbGSNaturalDiamondGradingCertificateItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
    '[name="natural_grading_certificate"]'
  );
  for (let i = 0; i < vdbGSNaturalDiamondGradingCertificateItemElements?.length; i++) {
    vdbGSNaturalDiamondGradingCertificateItemElements[i].addEventListener("click", async function () {
      window.NATURAL_LB_GROWN_DIAMOND.config.certificateValues = vdbGSNaturalDiamondGradingCertificateItemElements
        .filter((e) => e.checked)
        .map((e) => e.value)
        .join(",");
      await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });
  }
}

//LabGrown Diamond Cut active function
if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-lab-grown-diamond-cut-item")?.length > 0) {
  let vdbGSLabGrownDiamondCutItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-lab-grown-diamond-cut-item");
  for (let i = 0; i < vdbGSLabGrownDiamondCutItemElements?.length; i++) {
    vdbGSLabGrownDiamondCutItemElements[i].addEventListener("click", async function () {
      var hasActive = this.classList.contains("active");
      var cutValue = this.dataset.cutValue;

      vdbGSLabGrownDiamondCutItemElements.forEach((item) => item.classList.remove("active"));
      if (!hasActive) {
        this.classList.add("active");
      }
      window.NATURAL_LB_GROWN_DIAMOND.config.cutValues = cutValue;
      await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });
  }
}

// General Events
if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-sorting-th")?.length > 0) {
  let sortingThElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-sorting-th");
  for (let i = 0; i < sortingThElements.length; i++) {
    sortingThElements[i].addEventListener("click", async function () {
      for (var j = 0; j < sortingThElements.length; j++) {
        sortingThElements[j].classList.add("vdb_gs-sorting_desc");
        sortingThElements[j].classList.remove("vdb_gs-sorting_asc");
      }

      const clickedElement = this;
      const thSortingField = clickedElement.getAttribute("data-sorting_field");
      const hiddenSortingField = window.NATURAL_LB_GROWN_DIAMOND.config.sortingField;
      const hiddenSortingSeq = window.NATURAL_LB_GROWN_DIAMOND.config.sortingSeq;
      if (hiddenSortingField == thSortingField) {
        if (hiddenSortingSeq == "ASC") {
          window.NATURAL_LB_GROWN_DIAMOND.config.sortingSeq = "DESC";
          clickedElement.classList.add("vdb_gs-sorting_desc");
          clickedElement.classList.remove("vdb_gs-sorting_asc");
        } else {
          window.NATURAL_LB_GROWN_DIAMOND.config.sortingSeq = "ASC";
          clickedElement.classList.add("vdb_gs-sorting_asc");
          clickedElement.classList.remove("vdb_gs-sorting_desc");
        }
      } else {
        window.NATURAL_LB_GROWN_DIAMOND.config.sortingSeq = "ASC";
        clickedElement.classList.add("vdb_gs-sorting_asc");
        clickedElement.classList.remove("vdb_gs-sorting_desc");
      }
      window.NATURAL_LB_GROWN_DIAMOND.config.sortingField = thSortingField;
      await window.NATURAL_LB_GROWN_DIAMOND?.callBeforeLGDiamond();
    });
  }
}

if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-clear-all-filters")?.length > 0) {
  let vdbGSClearAllFiltersElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-clear-all-filters");
  for (let i = 0; i < vdbGSClearAllFiltersElements.length; i++) {
    vdbGSClearAllFiltersElements[i].addEventListener("click", async function (event) {
      event.stopPropagation();
      event.preventDefault();
      let shapeValues = "",
        priceMin = "",
        priceMax = "",
        caratMin = "",
        caratMax = "",
        tableMin = "",
        tableMax = "",
        depthMin = "",
        depthMax = "",
        colorValues = "",
        clarityValues = "",
        cutValues = "",
        fluorescenceValues = "",
        polishValues = "",
        symmetryValues = "",
        ratioMin = "",
        ratioMax = "",
        certificateValues = "";
      if (window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") == "Lab_grown_Diamond") {
        let vdbGSLabGrownDiamondShapeItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
          ".vdb_gs-auto_flex-grid .vdb_gs-lab-grown-diamond-shape-item"
        );
        labGrownDefaultShape.split(",").length > 1 &&
          vdbGSLabGrownDiamondShapeItemElements.forEach((item) => item.classList.remove("active"));
        shapeValues = "Round";

        labGrownPriceIonRangeSlider.data("ionRangeSlider").update({
          from: Number(labGrownDefaultPriceMin),
          to: Number(labGrownDefaultPriceMax),
        });
        priceMin = Number(labGrownDefaultPriceMin);
        priceMax = Number(labGrownDefaultPriceMax);

        labGrownCaratWeightIonRangeSlider.data("ionRangeSlider").update({
          from: Number(labGrownDefaultCaratMin),
          to: Number(labGrownDefaultCaratMax),
        });
        caratMin = Number(labGrownDefaultCaratMin);
        caratMax = Number(labGrownDefaultCaratMax);
        console.log("=====> check :::", labGrownDefaultTableTo);
        labGrownTableIonRangeSlider.data("ionRangeSlider")?.update({
          from: Number(labGrownDefaultTableFrom),
          to: Number(labGrownDefaultTableTo),
        });
        tableMin = Number(labGrownDefaultTableFrom);
        tableMax = Number(labGrownDefaultTableTo);

        labGrownDepthIonRangeSlider.data("ionRangeSlider")?.update({
          from: Number(labGrownDefaultDepthFrom),
          to: Number(labGrownDefaultDepthTo),
        });
        depthMin = Number(labGrownDefaultDepthFrom);
        depthMax = Number(labGrownDefaultDepthTo);

        labGrownRatioIonRangeSlider.data("ionRangeSlider")?.update({
          from: Number(labGrownDefaultRatioMin),
          to: Number(labGrownDefaultRatioMax),
        });
        ratioMin = Number(labGrownDefaultRatioMin);
        ratioMax = Number(labGrownDefaultRatioMax);

        labGrownColorIonRangeSlider.data("ionRangeSlider")?.update({
          from: labGrownColorInputValues[0],
          to: labGrownColorInputValues[labGrownColorInputValues?.length - 1],
        });
        colorValues = labGrownDefaultColor;

        labGrownClarityIonRangeSlider.data("ionRangeSlider").update({
          from: labGrownClarityInputValues[0],
          to: labGrownClarityInputValues[labGrownClarityInputValues?.length - 1],
        });
        clarityValues = labGrownDefaultClarity;

        let vdbGSLabGrownDiamondCutItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-lab-grown-diamond-cut-item");
        vdbGSLabGrownDiamondCutItemElements.forEach((item) => item.classList.remove("active"));
        cutValues = labGrownDefaultCut;

        labGrownFluorescenceIonRangeSlider.data("ionRangeSlider").update({
          from: labGrownFluorescenceInputValues[0],
          to: labGrownFluorescenceInputValues[labGrownFluorescenceInputValues?.length - 1],
        });
        fluorescenceValues = labGrownDefaultFluorescence;

        labGrownPolishIonRangeSlider.data("ionRangeSlider").update({
          from: labGrownPolishInputValues[0],
          to: labGrownPolishInputValues[labGrownPolishInputValues?.length - 1],
        });
        polishValues = labGrownDefaultPolish;

        labGrownSymmetryIonRangeSlider.data("ionRangeSlider").update({
          from: labGrownSymmetryInputValues[0],
          to: labGrownSymmetryInputValues[labGrownSymmetryInputValues?.length - 1],
        });
        symmetryValues = labGrownDefaultSymmetry;

        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('[name="lab_grown_grading_certificate"]').forEach((e) => (e.checked = false));
        certificateValues = labGrownDefaultGradingCertificate;
      } else {
        let vdbGSNaturalDiamondShapeItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(
          ".vdb_gs-auto_flex-grid .vdb_gs-diamond-shape-item"
        );
        // console.log(vdbGSNaturalDiamondShapeItemElements)
        naturalDefaultShape.split(",").length > 1 &&
          vdbGSNaturalDiamondShapeItemElements.forEach((item) => item.classList.remove("active"));
        // shapeValues = naturalDefaultShape;
        shapeValues = "Round";

        naturalPriceIonRangeSlider.data("ionRangeSlider").update({
          from: Number(naturalDefaultPriceMin),
          to: Number(naturalDefaultPriceMax),
        });
        priceMin = Number(naturalDefaultPriceMin);
        priceMax = Number(naturalDefaultPriceMax);

        naturalCaratWeightIonRangeSlider.data("ionRangeSlider").update({
          from: Number(naturalDefaultCaratMin),
          to: Number(naturalDefaultCaratMax),
        });
        caratMin = Number(naturalDefaultCaratMin);
        caratMax = Number(naturalDefaultCaratMax);

        naturalTableIonRangeSlider.data("ionRangeSlider").update({
          from: Number(naturalDefaultTableFrom),
          to: Number(naturalDefaultTableTo),
        });
        tableMin = Number(naturalDefaultTableFrom);
        tableMax = Number(naturalDefaultTableTo);

        naturalDepthIonRangeSlider.data("ionRangeSlider").update({
          from: Number(naturalDefaultDepthFrom),
          to: Number(naturalDefaultDepthTo),
        });
        depthMin = Number(naturalDefaultDepthFrom);
        depthMax = Number(naturalDefaultDepthTo);

        naturalRatioIonRangeSlider.data("ionRangeSlider").update({
          from: Number(naturalDefaultRatioMin),
          to: Number(naturalDefaultRatioMax),
        });
        ratioMin = Number(naturalDefaultRatioMin);
        ratioMax = Number(naturalDefaultRatioMax);

        naturalColorIonRangeSlider.data("ionRangeSlider").update({
          from: naturalColorInputValues[0],
          to: naturalColorInputValues[naturalColorInputValues?.length - 1],
        });
        colorValues = naturalDefaultColor;

        naturalClarityIonRangeSlider.data("ionRangeSlider").update({
          from: naturalClarityInputValues[0],
          to: naturalClarityInputValues[naturalClarityInputValues?.length - 1],
        });
        clarityValues = naturalDefaultClarity;

        let vdbGSNaturalDiamondCutItemElements = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb_gs-natural-diamond-cut-item");
        vdbGSNaturalDiamondCutItemElements.forEach((item) => item.classList.remove("active"));
        cutValues = naturalDefaultCut;

        naturalFluorescenceIonRangeSlider.data("ionRangeSlider").update({
          from: naturalFluorescenceInputValues[0],
          to: naturalFluorescenceInputValues[naturalFluorescenceInputValues?.length - 1],
        });
        fluorescenceValues = naturalDefaultFluorescence;

        naturalPolishIonRangeSlider.data("ionRangeSlider").update({
          from: naturalPolishInputValues[0],
          to: naturalPolishInputValues[naturalPolishInputValues?.length - 1],
        });
        polishValues = naturalDefaultPolish;

        naturalSymmetryIonRangeSlider.data("ionRangeSlider").update({
          from: naturalSymmetryInputValues[0],
          to: naturalSymmetryInputValues[naturalSymmetryInputValues?.length - 1],
        });
        symmetryValues = naturalDefaultSymmetry;

        NATURAL_LB_GROWN_DIAMOND.conObjToArrElements('[name="natural_grading_certificate"]').forEach((e) => (e.checked = false));
        certificateValues = naturalDefaultGradingCertificate;
      }

      NATURAL_LB_GROWN_DIAMOND.clearSortingIconElement();
      window.NATURAL_LB_GROWN_DIAMOND.config = {
        page_number: 1,
        diamondSearchType:
          window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") !== undefined
            ? window.NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type")
            : "Lab_grown_Diamond",
        shapeValues: shapeValues,
        colorValues: colorValues,
        clarityValues: clarityValues,
        cutValues: cutValues,
        priceMin: priceMin,
        priceMax: priceMax,
        caratMin: caratMin,
        caratMax: caratMax,
        tableMin: tableMin,
        tableMax: tableMax,
        depthMin: depthMin,
        depthMax: depthMax,
        fluorescenceValues: fluorescenceValues,
        polishValues: polishValues,
        symmetryValues: symmetryValues,
        ratioMin: ratioMin,
        ratioMax: ratioMax,
        certificateValues: certificateValues,
        sortingField: defaultSortingField,
        sortingSeq: defaultSortingSeq,
      };
      await window.NATURAL_LB_GROWN_DIAMOND.callBeforeLGDiamond();
    });
  }
}

if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-apply-filters")?.length > 0) {
  let vdbGSApplyFilters = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".vdb-gs-apply-filters");
  for (let i = 0; i < vdbGSApplyFilters?.length; i++) {
    vdbGSApplyFilters[i].addEventListener("click", function () {
      NATURAL_LB_GROWN_DIAMOND.hideElements(".vdb_gs_filters");
      screen.width <= 1200 && NATURAL_LB_GROWN_DIAMOND.showElements(".vdb_gs_list");
    });
  }
}

if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".button--add-to-cart")?.length > 0) {
  const buttonAddToCartElement = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".button--add-to-cart");
  for (let i = 0; i < buttonAddToCartElement?.length; i++) {
    buttonAddToCartElement[i].addEventListener("click", function () {
      let _this = this;
      const selectedDiamondId = this.dataset.selectedDiamondId;
      const productJson =
        document.querySelector("[data-selected-diamond-product]") && document.querySelector("[data-selected-diamond-product]").innerHTML;
      const productObj = JSON.parse(productJson);

      const $addToCartBtn = document.querySelector(".button--add-to-cart");
      const niceFrame = $addToCartBtn?.querySelector(".nice-frame");

      $addToCartBtn.setAttribute("disabled", "disabled");
      $addToCartBtn.classList.add("disabled");
      niceFrame && (niceFrame.textContent = "Adding item...");

      if (Object.keys(productObj)?.length > 0) {
        var formData = new FormData();
        formData.append("action", "createProduct");
        formData.append("shop", Shopify.shop);
        formData.append("product_title", productObj?.long_title);
        formData.append("product_price", productObj?.total_sales_price);
        formData.append("stock_id", productObj?.id);
        formData.append("stock_num", productObj?.stock_num);
        formData.append("vendor_id", productObj?.vendor_id);
        formData.append(
          "product_img",
          productObj?.image_url?.length > 0 ? productObj?.image_url : `${window.location.origin}${baseAppProxy}/images/no-image.png`
        );
        formData.append("is_lab", NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") == "Lab_grown_Diamond" ? "1" : "0");

        fetch(`${baseAppProxy}/frontend.php`, {
          method: "POST",
          body: formData,
        })
          .then((response) => response.text())
          .then((result) => {
            let resultObj = JSON.parse(result);
            if (resultObj.isSuccess == "1") {
              var groupId = Array.from(Array(30), () => Math.floor(Math.random() * 36).toString(36)).join("");
              var tempGroupId = groupId;
              let formData = {
                items: [
                  {
                    id: document.querySelector("variant-selection").variant, // defaultVariantId
                    quantity: 1,
                    properties: {
                      _groupId: tempGroupId,
                      "Ring Size":
                        document.getElementById("data-variant-option-ring-size").value != "Send ring sizer"
                          ? document.getElementById("data-variant-option-ring-size").value
                          : "",
                    },
                  },
                  {
                    id: resultObj.var_id,
                    quantity: 1,
                    properties: {
                      _groupId: tempGroupId,
                      _stone_reference_id: productObj?.vendor_id,
                    },
                  },
                ],
              };

              $addDiamondToCartTry = 0;
              NATURAL_LB_GROWN_DIAMOND.addToCart(formData, $addToCartBtn, niceFrame);
            }
          });
      } else {
        swal("Oops!", "Something went wrong please try again later!", "error");

        $addToCartBtn.removeAttribute("disabled", "disabled");
        $addToCartBtn.classList.remove("disabled");
        niceFrame && (niceFrame.textContent = "Add to cart");
      }
    });
  }
}

if (NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".close_modal")?.length > 0) {
  const closeModalElement = NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".close_modal");
  for (let i = 0; i < closeModalElement?.length; i++) {
    closeModalElement[i].addEventListener("click", function (e) {
      e.preventDefault();

      document.getElementById("vdb_gs_polish_modal") && (document.getElementById("vdb_gs_polish_modal").style.display = "none");
      document.getElementById("vdb_gs_cert_video_modal") && (document.getElementById("vdb_gs_cert_video_modal").style.display = "none");
      document.getElementById("myCertImg") && (document.getElementById("myCertImg").src = "");
      document.getElementById("myCertAndVideoFrame") && (document.getElementById("myCertAndVideoFrame").src = "");

      document.documentElement.classList.remove("modal_open");
    });
  }
}

const $selectYourDiamondBtn = document.querySelector(".button--select-your-diamond");
const niceFrame = $selectYourDiamondBtn?.querySelector(".nice-frame");

window.addEventListener("custom-variant-change", function (event) {
  const isVariant = document.querySelector("variant-selection").variant;

  $selectYourDiamondBtn.setAttribute("disabled", "disabled");
  $selectYourDiamondBtn.classList.add("disabled");
  niceFrame && (niceFrame.textContent = isVariant == "unavailable" ? "Unavailable" : $selectYourDiamondBtn.dataset.label);
  if (event.detail.variant && document.getElementById("data-variant-option-ring-size").value?.length > 0) {
    $selectYourDiamondBtn.removeAttribute("disabled", "disabled");
    $selectYourDiamondBtn.classList.remove("disabled");
    niceFrame &&
      (niceFrame.textContent =
        document.querySelector("[data-selected-diamond-product]").innerHTML.length > 0 ? "View" : $selectYourDiamondBtn.dataset.label);
  }
});

if (document.getElementById("data-variant-option-ring-size")) {
  document.getElementById("data-variant-option-ring-size").addEventListener("change", function (event) {
    $selectYourDiamondBtn.setAttribute("disabled", "disabled");
    $selectYourDiamondBtn.classList.add("disabled");
    if (this.value?.length > 0) {
      $selectYourDiamondBtn.removeAttribute("disabled", "disabled");
      $selectYourDiamondBtn.classList.remove("disabled");
    }
  });
}

if (document.getElementById("vdb-gs-advanced-filter-view")) {
  document.getElementById("vdb-gs-advanced-filter-view").addEventListener("click", function (e) {
    e.preventDefault();
    NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(".advance-filter-web").forEach((e) => e.classList.add("hide"));
    if (this.dataset.filter == "open") {
      const type = NATURAL_LB_GROWN_DIAMOND.getUrlParameter("type") == "Diamond" ? "natural" : "labGrown";
      NATURAL_LB_GROWN_DIAMOND.conObjToArrElements(`.advance-filter-web[data-type="${type}"]`).forEach((e) => e.classList.remove("hide"));
      this.dataset.filter = "close";
      console.log("=======> type", type);
      if (type == "natural") {
        let objDiv = document.getElementById("vdb_gs_natural-diamonds");
        // objDiv.scrollTop = objDiv.scrollHeight;

        objDiv.scrollTo({
          top: objDiv.scrollHeight,
          behavior: "smooth",
        });
      } else {
        let objDiv = document.getElementById("vdb_gs_lab-grown-diamonds");
        // objDiv.scrollTop = objDiv.scrollHeight;
        objDiv.scrollTo({
          top: objDiv.scrollHeight,
          behavior: "smooth",
        });
      }
    } else {
      this.dataset.filter = "open";
    }
  });
}

// Wait for the DOM to be fully loaded
document.addEventListener("DOMContentLoaded", function () {
  // Get the filter button and filter overlay elements
  const filterButton = document.querySelector(".filter-button a");
  const filterOverlay = document.querySelector(".filter-overlay");
  const filtersContainer = document.querySelector(".vdb_gs_filters");
  const closeModalBtn = document.querySelector(".vdb_gs-close_modal");

  // Function to show the filter sidebar
  function showFilterSidebar() {
    // Add active class to show the sidebar
    filtersContainer.classList.add("active");
    // Show the overlay
    filterOverlay.classList.remove("filter-overlay--hidden");
    // Prevent body scrolling
    document.body.style.overflow = "hidden";
  }

  // Function to hide the filter sidebar
  function hideFilterSidebar() {
    // Remove active class to hide the sidebar
    filtersContainer.classList.remove("active");
    // Hide the overlay
    filterOverlay.classList.add("filter-overlay--hidden");
    // Restore body scrolling
    document.body.style.overflow = "";
  }

  // Add click event listener to the filter button
  if (filterButton) {
    filterButton.addEventListener("click", function (e) {
      e.preventDefault();
      showFilterSidebar();
    });
  }

  // Close the sidebar when clicking on the overlay
  if (filterOverlay) {
    filterOverlay.addEventListener("click", hideFilterSidebar);
  }

  // Close the sidebar when clicking on the close button
  if (closeModalBtn) {
    closeModalBtn.addEventListener("click", hideFilterSidebar);
  }

  // Also handle the existing filter button at the top (if present)
  const vdbFilterBtn = document.getElementById("vdb_gs_filter_btn");
  if (vdbFilterBtn) {
    vdbFilterBtn.addEventListener("click", showFilterSidebar);
  }

  // Add event listener to apply filters button
  const applyFiltersBtn = document.querySelector(".vdb-gs-apply-filters");
  if (applyFiltersBtn) {
    applyFiltersBtn.addEventListener("click", hideFilterSidebar);
  }
});

// END GS

// Add this function to update filter counts in both mobile and desktop elements
function updateFilterCount() {
  // Get all applied filters
  const activeFilters = [];

  // Count active shapes
  const activeShapes = document.querySelectorAll(".vdb_gs-diamond-shape-item.active, .vdb_gs-diamond-shape-item.is-active-shape");
  if (activeShapes.length) {
    activeFilters.push("shape");
  }

  // Check price filter
  const currentType = window.NATURAL_LB_GROWN_DIAMOND.config.diamondSearchType === "Diamond" ? "natural" : "lab_grown";

  // Price range
  const priceMin = window.NATURAL_LB_GROWN_DIAMOND.config.priceMin;
  const priceMax = window.NATURAL_LB_GROWN_DIAMOND.config.priceMax;
  const defaultPriceMin = currentType === "natural" ? Number(naturalDefaultPriceMin) : Number(labGrownDefaultPriceMin);
  const defaultPriceMax = currentType === "natural" ? Number(naturalDefaultPriceMax) : Number(labGrownDefaultPriceMax);

  if (priceMin !== defaultPriceMin || priceMax !== defaultPriceMax) {
    activeFilters.push("price");
  }

  // Carat weight
  const caratMin = window.NATURAL_LB_GROWN_DIAMOND.config.caratMin;
  const caratMax = window.NATURAL_LB_GROWN_DIAMOND.config.caratMax;
  const defaultCaratMin = currentType === "natural" ? Number(naturalDefaultCaratMin) : Number(labGrownDefaultCaratMin);
  const defaultCaratMax = currentType === "natural" ? Number(naturalDefaultCaratMax) : Number(labGrownDefaultCaratMax);

  if (caratMin !== defaultCaratMin || caratMax !== defaultCaratMax) {
    activeFilters.push("carat");
  }

  // Color
  const colorValues = window.NATURAL_LB_GROWN_DIAMOND.config.colorValues;
  const defaultColor = currentType === "natural" ? naturalDefaultColor : labGrownDefaultColor;

  if (colorValues !== defaultColor) {
    activeFilters.push("color");
  }

  // Clarity
  const clarityValues = window.NATURAL_LB_GROWN_DIAMOND.config.clarityValues;
  const defaultClarity = currentType === "natural" ? naturalDefaultClarity : labGrownDefaultClarity;

  if (clarityValues !== defaultClarity) {
    activeFilters.push("clarity");
  }

  // Cut
  const cutValues = window.NATURAL_LB_GROWN_DIAMOND.config.cutValues;
  const defaultCut = currentType === "natural" ? naturalDefaultCut : labGrownDefaultCut;

  if (cutValues !== defaultCut) {
    activeFilters.push("cut");
  }

  // Fluorescence
  const fluorValues = window.NATURAL_LB_GROWN_DIAMOND.config.fluorescenceValues;
  const defaultFluor = currentType === "natural" ? naturalDefaultFluorescence : labGrownDefaultFluorescence;

  if (fluorValues !== defaultFluor) {
    activeFilters.push("fluorescence");
  }

  // Polish
  const polishValues = window.NATURAL_LB_GROWN_DIAMOND.config.polishValues;
  const defaultPolish = currentType === "natural" ? naturalDefaultPolish : labGrownDefaultPolish;

  if (polishValues !== defaultPolish) {
    activeFilters.push("polish");
  }

  // Symmetry
  const symmetryValues = window.NATURAL_LB_GROWN_DIAMOND.config.symmetryValues;
  const defaultSymmetry = currentType === "natural" ? naturalDefaultSymmetry : labGrownDefaultSymmetry;

  if (symmetryValues !== defaultSymmetry) {
    activeFilters.push("symmetry");
  }

  // Table
  const tableMin = window.NATURAL_LB_GROWN_DIAMOND.config.tableMin;
  const tableMax = window.NATURAL_LB_GROWN_DIAMOND.config.tableMax;
  const defaultTableMin = currentType === "natural" ? Number(naturalDefaultTableMin) : Number(labGrownDefaultTableMin);
  const defaultTableMax = currentType === "natural" ? Number(naturalDefaultTableMax) : Number(labGrownDefaultTableMax);

  if ((tableMin !== "" && tableMin !== defaultTableMin) || (tableMax !== "" && tableMax !== defaultTableMax)) {
    activeFilters.push("table");
  }

  // Depth
  const depthMin = window.NATURAL_LB_GROWN_DIAMOND.config.depthMin;
  const depthMax = window.NATURAL_LB_GROWN_DIAMOND.config.depthMax;
  const defaultDepthMin = currentType === "natural" ? Number(naturalDefaultDepthMin) : Number(labGrownDefaultDepthMin);
  const defaultDepthMax = currentType === "natural" ? Number(naturalDefaultDepthMax) : Number(labGrownDefaultDepthMax);

  if ((depthMin !== "" && depthMin !== defaultDepthMin) || (depthMax !== "" && depthMax !== defaultDepthMax)) {
    activeFilters.push("depth");
  }

  // Certificate
  const labValues = window.NATURAL_LB_GROWN_DIAMOND.config.certificateValues;
  const defaultLab = currentType === "natural" ? naturalDefaultGradingCertificate : labGrownDefaultGradingCertificate;

  if (labValues !== defaultLab) {
    activeFilters.push("certificate");
  }

  // Update the count on all filter count elements
  const filterCountElements = document.querySelectorAll(".filter-count, .vdb_gs-filter-count");
  filterCountElements.forEach((element) => {
    element.textContent = `(${activeFilters.length})`;
  });

  // Return the count for other functions to use
  return activeFilters.length;
}

// Hook into the filter reset and callBeforeLGDiamond functions to update filter count
const originalCallBeforeLGDiamond = window.NATURAL_LB_GROWN_DIAMOND.callBeforeLGDiamond;
window.NATURAL_LB_GROWN_DIAMOND.callBeforeLGDiamond = async function () {
  const result = await originalCallBeforeLGDiamond.apply(this, arguments);
  updateFilterCount();
  return result;
};

// Initialize filter count on page load
document.addEventListener("DOMContentLoaded", function () {
  // Set initial filter count
  updateFilterCount();

  // Attach to all filter change events
  const rangeSliders = document.querySelectorAll(".js-range-slider");
  rangeSliders.forEach((slider) => {
    $(slider).on("change", function () {
      setTimeout(updateFilterCount, 100);
    });
  });

  // Also update after shape selections
  const shapeItems = document.querySelectorAll(".vdb_gs-diamond-shape-item");
  shapeItems.forEach((item) => {
    item.addEventListener("click", function () {
      setTimeout(updateFilterCount, 100);
    });
  });

  // Update after certificate checkbox changes
  const certCheckboxes = document.querySelectorAll('[name="lab_grown_grading_certificate"], [name="natural_grading_certificate"]');
  certCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      setTimeout(updateFilterCount, 100);
    });
  });

  // Update after diamond type changes
  const tabButtons = document.querySelectorAll(".vdb-gs-tab-wrap li a");
  tabButtons.forEach((button) => {
    button.addEventListener("click", function () {
      setTimeout(updateFilterCount, 100);
    });
  });

  // Update when filters are reset
  const resetButtons = document.querySelectorAll(".vdb-gs-clear-all-filters");
  resetButtons.forEach((button) => {
    button.addEventListener("click", function () {
      setTimeout(function () {
        // Reset the filter count to zero after clear
        const filterCountElements = document.querySelectorAll(".filter-count, .vdb_gs-filter-count");
        filterCountElements.forEach((element) => {
          element.textContent = "(0)";
        });
      }, 100);
    });
  });
});
